import { ArrowLeft } from "lucide-react"
import { Footer } from "@/components/Footer"
import { getEventSlugFromUrl, eventPath } from "@/lib/utils"

const TERMS_SECTIONS: Array<{
  title: string
  content?: string
  subsections?: Array<{ title: string; content: string }>
}> = [
    {
      title: "General Commercial Terms & Conditions",
      content: `General Commercial Terms &
Conditions
Owner and operator of website portal www.pelikan.sk
Commercial name: pelicantravel.com s.r.o.
Registered office: Pribinova 17954/10, 811 09 Bratislava, Slovenská republika
Registered in the Commercial Registry of the Municipal court of Bratislava III,
section SRO, file no. 32895/B.
ID: 35987821
TIN: 2021871225
VAT ID: SK2021871225

Contacts:
Flights
letenky@pelikan.sk
02 / 5464 9494
Holidays
pobyty@pelikan.sk
02 / 3216 6321
(hereinafter referred to as ‘Pelikán’)
aktualizované dňa: 21.11.2025`,
    },
    {
      title: "A. GENERAL TERMS FOR FLIGHT TICKETS SALE",
    },
    {
      title: "B. GENERAL CONTRACT TERMS AND CONDITIONS FOR SALE OF CK PELIKÁN",
      content: `PACKAGE TOURS`,
      subsections: [
        {
          title: "IX. Change in agreed services after starting a Tour",
          content: `X.

X. Withdrawal from the tour contract by the traveler and the compensation`,
        },
        {
          title: "XI. Complaint procedure, responsibility for the provision of the tour,",
          content: `compensation for damages`,
        },
      ],
    },
    {
      title: "C. GENERAL CONTRACTUAL CONDITIONS FOR SALE OF ACCOMMODATION",
      subsections: [
        {
          title: "XIV. Some provisions on cancellation conditions and supplementary conditions",
          content: `valid for villas and apartments`,
        },
      ],
    },
    {
      title: "D. GENERAL TERMS AND CONDITIONS OF THE AGENCY FOR INSURANCE, VISA,",
      content: `TRANSFERS, PARKING CARDS, PREMIUM ASSISTANCE SERVICES AND OTHER
SERVICES`,
      subsections: [
        {
          title: "VIII. Gift vouchers",
          content: `a. Special gift vouchers
b. Discount code`,
        },
      ],
    },
    {
      title: "E. COMMON PROVISIONS OF THE GENERAL TERMS AND CONDITIONS",
      content: `APPLICABLE TO THE SALES OF AIRLINE TICKETS, TOURS,
ACCOMMODATIONS, INSURANCE ARRANGEMENTS AND SALES OF OTHER
PRODUCTS/SERVICES`,
    },
    {
      title: "F. GENERAL CONDITIONS OF CARRIAGE FOR AIR CARRIERS, IATA MEMBERS",
    },
    {
      title: "G. PRICELIST OF CHARGES IN THE GENERAL COMMERCIAL TERMS AND",
      content: `CONDITIONS`,
      subsections: [
        {
          title: "II. Types of charge",
          content: `A. GENERAL TERMS FOR FLIGHT TICKETS SALE`,
        },
        {
          title: "I. Definitions",
          content: `1. BOOKING – electronic information about a client in the global
reservation system and in the system of the specific carrier the client will
fly with. This data contains passenger information – name and surname,
gender, date of birth (for children, youth, students, infants, and senior
citizens), precise time and geographic travel plan including information
about air carrier and flights. It may also include special requests of the
client and information about a seat booking if the reservation of the
particular seat on a given route is allowed by the airline. If this is not
allowed, the seat can be reserved at check-in.
2. GROUP BOOKING – a reservation that requires a minimum of 10
passengers travelling on the same booking.
3. FLIGHT TICKET – is a contract between the client and the airline (air
carrier) to ensure the transport of a passenger and their luggage and, if
applicable, other services linked with such carriage to the extent stated
on the flight ticket. At the time of payment for the ticket, the client
automatically voluntarily agrees to this contract and its terms and
conditions, to the conditions of the tariff for which the reservation was
made and, therefore, to the cancellation conditions and possible ticket
changes. Current terms and conditions of this contract are available to
the client during booking placement, and they are also available on the
airlines' websites. The contract is concluded when the flight ticket is
issued/purchased by a particular airline. The client is informed of the
contract conclusion via email.
In this process, the company Pelikán acts solely as a payment
intermediary on behalf of the passenger when arranging the
transportation of the passenger and their baggage. The client pays the
total ticket price to Pelikán, which then transfers the amount to the
airline through IATA – International Air Transport Association. Therefore,
Pelikán is not responsible for any damages caused to the client due to
non-delivery of the airline´s services. The airline, as an air carrier which
is to transport the client in compliance with the client´s contract, is fully
responsible for any possible damages.
For information on the Common Rules of the Compensation Scheme and
assistance to passengers refusing to board the aircraft, in the event of a
cancellation or long delays, established by the European Parliament and
the Council of the European Union please call 00 800 67891011 or, for
written information in several languages, visit https://ec.europa.eu
/transport/themes/passengers/air_en
4. ELECTRONIC FLIGHT TICKET – is information of the airline
electronic system in which all flight details are safely stored. The client is

not obliged to have an electronic flight ticket with them at the check-in
counter at the airport. However, Pelikán recommends that clients have
confirmation of an electronic flight ticket with them.
5. PAPER FLIGHT TICKET - is a transport ticket that you must always
physically have with you when you depart, and you must submit it at the
check-in counter at the airport.
6. BOARDING PASS - a document issued by the airline (in paper or
electronic form) after completing online check-in or during airport checkin at the airport. It confirms that the passenger is registered (checked in)
for a specific flight and has been assigned a seat on the aircraft. The
boarding pass must always be physically available (in printed or
electronic form) when departing. Without a boarding pass, the passenger
will be denied boarding and the provision of transport services under the
carriage contract.
A boarding pass may also be provided to the passenger electronically via
the airline’s mobile application, and some airlines may require it to be
presented exclusively in this electronic form. The boarding pass usually
indicates the time when boarding begins (“Gate opens”) and the time
when boarding closes (“Gate closes”). After boarding has closed,
passengers who are not yet on board are no longer permitted to enter
the aircraft.
7. FLIGHT TICKET PRICE – price or air transport services.
8. AIRPORT FEES – fees levied by the city, state, or country of
departure. Usually, this fee is collected at the same time when the ticket
is purchased – with the ticket price – in some cases, airport fees are paid
at the airport (especially in some countries in Asia, Africa, and South
America).
9. SERVICE CHARGE PELIKÁN – This represents the fee for facilitating
the client's ticket purchase. It also includes Pelikán's expenses, such as
technology and administration costs related to the ticket purchase
facilitation.
10. Additional Passenger Information - APIS (Advance Passenger
Information System)
Based on the relevant national legislation of particular countries, some
airlines (especially for international flights) require additional passenger
information on the reservation prior to departure. These are data such as
the passport number (or the number of the national ID card if it is
possible to travel to a particular country with this document),
passenger´s nationality, date of birth, gender, country of issue and
expiration date of the travel document, place of residence
(whereabouts), etc. This information must be included in a reservation
prior to the departure. To ensure an uneventful departure and flight, as
well as the entry to a country of the final destination or a country of a
stopover, it is important to provide correct and true information.
Passengers are responsible for providing the correct information on time.
The information of each passenger must be provided to the airline or

Pelikán. If this information is given to Pelikán, Pelikán will provide the
information to the airline. The information can be entered immediately
after the ticket has been purchased and prior to departure via the
Manage my booking section on www.pelikan.sk (“Kontrola rezervácie”) in
case the data entry is enabled for the combination of flights or via e-mail,
at least 3 days prior to departure. If the ticket is purchased less than 3
days prior to departure, the passengers must enter this information
immediately after receiving the ticket via the Manage my booking section
on www.pelikan.sk if the data entry is enabled for the combination of
flights, or to send the information to Pelikán via email. If the passenger
fails to deliver this information on time, or if any of the information is
incorrect or not delivered at all, the airline may charge for correcting the
passenger´s flight ticket and/or for steps associated with issuing a new
boarding pass either at the airport or later via Pelikán. It is also possible
that the airline will refuse to transport the passenger without a refund of
unused flight tickets. If a fine (sanction) is applied through Pelikán,
Pelikán has the right to recover this sanction from the passenger who
breached the information obligation that was the cause of the fine on the
part of the air carrier.`,
        },
        {
          title: "II. Conditions and a method of placing a booking",
          content: `1. Pelikán operates an online information system on the web portal www.
pelikan.sk or, on the web portal of Pelikán´s partner offering a service
that allows a client to find currently available flight connections according
to the client’s requirements via the search form (the place of departure
to the desired destination, the date of departure, the place where the
client wishes to return from, the date of return departure…) and to make
a booking for the selected flight connection. After the client makes a
booking, Pelikán generates a booking confirmation based on the payment
method selected by the client. The client then receives an invoice or
confirmation of a successful payment. Pelikán charges a service fee per
person, according to the current T&C (section G). In the first step of the
order, the lowest price for the selected ticket in the offer is indicated,
where the highest possible discount on the service charge, which the
company Pelikán may provide for this ticket, is applied. Various amounts
of discounts on the service charge may be applied to the ticket, and the
ticket may be in the Pelikán's offer even without a discount on the
service charge. The actual amount of service charge and individual
discounts are produced by the system algorithm, the specifications of
which are subject to trade secret, but the client can see it in the price list
breakdown, always before commencing of a payment transaction. If the
client is interested in receiving an offer made by one of our Customer
Service agents, they can send their request using the contact details in
the tab “Contacts” or send the request using their own e-mail address.
It is not possible to make a complicated booking via the online
reservation system. A complicated booking is a booking which includes
more separate flights, or more precisely, more flight tickets or a booking

with a stopover during which the client interrupts their journey by
staying in a transit city for several days on the way to or from a final
destination.
Such requests can be sent to the e-mail address of our Customer
Service. After an offer is accepted by the client, a Customer Service
agent will send details for a payment to the client via email. A service fee
per person (according to current T&C - section G) is always charged
when making a booking via the Customer Service .
The client has to provide an e-mail address and telephone number at
which they can be reached until the end of the journey. Otherwise, they
may not be informed on time/accurately of any changes to the timetable
or cancellation of flights that affect their flight ticket and travel. As this
information can be sent via text message (SMS), the client is required to
provide a mobile phone number that can receive text messages (SMS). If
the client does not provide a mobile number, the client will be contacted
via e-mail.

2. The client can view the current number of free seats on an aircraft and
current prices 24 hours a day. Reservation for specific flights can only be
made if the client wishes to depart at least 2 calendar days later than the
date the actual state is viewed by the client. If the departure is only 1
calendar day later than the date the actual state is viewed by the client,
it is not possible to make a flight reservation, however, the client can
purchase a ticket for the selected flights only when booking an online
ticket, and only by means of a credit card.
Example: On 10th October (whole day, CET) it is not possible to make a
reservation for flights on 10th and 11th October (the date and time of
departure being the decisive factor). For these days, however, it will be
possible to view currently available flights and prices of flights tickets.
The earliest reservation can be made for a flight departing on 12th
October from 00:01 (time at the place of departure). However, it will be
possible to buy the flight ticket online and pay by credit card for a flight
departing on 11th October at 00:01 (time at the place of departure).

3. Once a reservation has been made, the client receives an
automatically generated reservation code and reservation confirmation
will be sent to the client via e-mail. The client is required to check the
reservation on the website in “Order management” section by entering
the reservation code into the “Reservation code” box and entering the
surname (without diacritic) of the passenger who made the reservation
into the “Surname” box.
If during the reservation process the client opts for immediate payment,
the client is required to check their reservation in the reservation step
“Reservation Summary and Payment method” before making a booking
and being redirected to the selected payment gateway.

If there are any discrepancies or errors related to the information in the
reservation, the client is required to contact Pelikán immediately in
writing via e-mail or by phone prior to the payment.
A discrepancy is, for example, an incorrect name or surname or gender
of the passenger, in some cases it may be the first name in a place of the
surname and vice versa, giving an academic degree instead of the title
Mr./Mrs., just one name of the passenger if there are two names on their
travel document, just one surname of the passenger if there are two
surnames on their travel document, etc. If the client provides two names
or two surnames separated by a space, after processing the reservation
in the reservation system, these can be displayed without a space on the
flight ticket. This, however, is not considered a discrepancy and the client
can use the flight ticket. If the client does not check the reservation and
does not inform Pelikán about discrepancies prior to payment, Pelikán is
not responsible for any potential damage that might arise to the client
due to such actions and discrepancies in the reservation. If the
reservation is cancelled due to discrepancies in the reservation and it is
not possible to make a new reservation for the identical flights, or more
precisely, the new reservation can be made only at a higher price,
Pelikán is not responsible for the consequences of cancelling the original
reservation.
Pelikán recommends that the client checks the following information, in
particular:
1) name and surname in the format as displayed in the valid travel
document which the client will use when travelling, gender
2) city of departure and return as well as the transit cities
3) dates of departure and return
4) flight times
5) section – Flight service information – go to this section. Here you can
find information such as planned stopover (for refuelling) if it is a longhaul flight. In such cases passengers continue their journey on the same
aircraft, therefore this transit point is not on the itinerary. It is required
to leave the aircraft during refuelling, therefore passengers have to check
their visa requirements for cities and countries where the aforementioned
situation might occur.
In this section, the client can also find additional flight information such
as flight duration, aircraft type, confirmation/rejection of requested type
of food, seat or another extra service.
Pelikán has the right to demand 100% of the ticket price and all ordered
services when the contract for ticket mediation is concluded.
Alternatively, the client may be offered the option to split the payment
for the order (so-called Flexi Payment), which includes the ticket,
depending on the total order price and the departure date. Flexi Payment
is a paid service that allows the reservation to be issued upon receiving

an individually agreed portion of the order value. The required amount is
specified in the online booking process (for online orders), in the Order
Summary (for offline orders), as well as in the proforma invoice and final
invoice (for both online and offline orders). The Flexi Payment fee is nonrefundable.
A deposit of at least 34% of the total order price is due on the day the
order is created. The remaining balance(hereinafter referred to as the
"balance payment") to cover the full order price must be paid by the
client (the purchaser) no later than 35 days before the departure date or
the start of services. The amount and due date of the balance payment
will be individually agreed upon with the client before the contract is
finalized. Instructions on payment methods and deadlines will also be
included in the order confirmation and order management details. Some
services included in the order may require full payment upfront, meaning
the client must settle these in full on the day the order is created. The
amount paid will then be proportionally allocated toward covering the
remaining services in the order.
If an order includes multiple travelers, the price for the ordered services
is indivisible among the individual travelers and constitutes a joint
obligation. If the full order price has not been paid, none of the travelers
is entitled to partial fulfillment (i.e., use of the ordered services).
By paying the deposit, the client undertakes to paying the full price for
the ordered services and agrees to the terms for paying the remaining
balance according to the due dates specified.
The usability of flight tickets and the possibility of making changes to
tickets, as well as the availability of certain services such as "Change for
Any Reason" and "Flight Delay Insurance Upon Arrival," is contingent on
the full payment of the total order price. In the case of cancellation
insurance with one of the insurance products from the European Travel
Insurance Company, this insurance can be utilized even before the full
payment of the order amount. However, insurance claims can only be
made for the portion of the insured services that the client has already
paid for, minus the amount of the insurance itself. .
If an order that has not been fully paid is canceled, the eligibility for a
potential refund for unused services will be determined based on the
ticket conditions set by the airline. The client will be refunded the
difference between the refunded amount and any remaining unpaid
balance(s) for the order.
If the client fails to pay the balance amount on time, Pelikán reserves the
right to cancel the ordered services without compensation. In such a
case, the deposit along with any partial payments made are nonrefundable, and the client is not entitled to a refund of the amounts
already paid for the order.
A condition for using the Flexi Payment option is that the person who
created the order including the Flexi Payment service (the ticket
purchaser) is also one of the travelers. If the purchaser is not one of the

travelers, Pelikán reserves the right to cancel the Flexi Payment service,
as well as the tickets and all ordered products and services, without
compensation.
4. After the reservation is processed successfully at www.pelikan.sk, a
“Thank you” window willbe open and here, the client will see the
reservation code and the flight information. The client will automatically
receive an email with Reservation confirmation and Proforma invoice
where the client can see all the important information necessary for
payment. The period of the validity of the reservation is given by the
reservation system based on the conditions of airline applicable to a
particular tariff. Only payments credited to Pelikán bank accounts within
the due date specified in the Payment documentation, for the relevant
form of payment (chosen by the client), will be processed. However, the
airline may shorten the due date. In such case Pelikán informs the client
about the new shortened due date. If the client wants to pay for the
reservation on a different day than the date of the booking, we
recommend them to check the current price of the flight ticket with our
Client Service Center before processing the payment. If the client fails to
pay the total price by the due date stated in the Payment documentation,
the reservation will be automatically canceled by the system without any
claim for the damages that would arise.
Pelikán reserves the right to refuse to issue a flight ticket if the ticket
cannot be issued due to a system error seeing that this error can be
caused by a temporary or a permanent technical failure which causes
a display of non-existent flights, sold out flights shown as available or
showing a price that is apparently too low, etc.
If the ticket cannot be issued for the reasons stated above, Pelikán will
inform the client as soon as possible and offer the client an alternative
solution that suits the client the best and meets the client´s
transportation requirements.
If the client does not agree to any of the offered options, Pelikán will
immediately return to the client the full payment received in the same
way as the client used for the payment.
In special cases, during placing an online booking, the reservation
system technical failure may occur or the client fails to finish the
reservation process (the client exceeds the limit for an online payment
and the reservation session expires) or during the reservation process
the flight tickets, at the particular price, are sold out or there is a
reasonable suspicion of a misuse of credit card which the client uses for
the payment, the airline carrier substantially shortens the due date etc.,
the chosen flight tickets and services related to them may not be booked
/issued by Pelikán. If this happens, Pelikán informs the client about the
situation as soon as possible and offers solutions. If any of the offered
alternatives (solutions) do not suit the client and the client has already
paid the reservation, Pelikán will pay the full refund and the money will
be sent back to the client´s account which the client used to pay for the

tickets. The client is not entitled to compensation for any damages
resulting from the reservation process failure/issuance of flight ticket
failure due to these unusual circumstances.

5. It is essential that all the information is true and correct. This
information serves to identify the client and their reservation in further
communication. If an airline requires additional information to issue the
ticket (passport number, ID number, miles and more card number, ID
copy, passport copy, credit card number) the client will be informed
about this by phone or via email to the email address the client provided.
If the client does not provide such documents on time, Pelikán reserves
the right to not to deliver the service/ product without any claim for
damages that would have arisen to the client in the event of not
delivering the service/product to the client. By providing the information
and by completing the reservation process, the client agrees with the
processing of personal data in order to issue the flight ticket. If the client
presents false or incomplete information, Pelikán reserves the right to
immediately cancel the reservation or to modify the price or to receive
compensation to the full amount for any damages caused by presenting
false information. In this case, Pelikán is not responsible for any damages
incurred to the client.

6. Reservations can be updated, changed or cancelled prior to payment.
Once the ticket is issued, all changes are subject to the cancellation
policy of a particular ticket tariff. The client has to check the information
about the policy prior to payment and issuance of the flight ticket.
The conditions for flight tickets are provided directly by an airline and
exclusively in English (with the exception of some low-cost airline
companies). It is not possible to send these in other languages. If the
client does not understand the conditions or these are not displayed to
the client, we recommend that the client contacts our Customer Service
before paying for the ticket.
We recommend that the client reads the terms and conditions in full and
focuses on the following in particular:
Booking and issuing of flight tickets – information on the period in which
the reservation is valid and on the date of issuing the ticket
Minimum stay – the minimum time to spend in the destination to meet
the condition
Maximum stay – the maximum stay that cannot be exceeded when
staying in a country (including a change of the date) in order to keep the
conditions unchanged.
Travel restrictions – especially in the event of a change in the ticket.
When the conditions of a given price are or are not in force.

Fines – information on the options and fees for a change and a
cancellation.
The conditions for a change and a cancellation are set separately for each
flight ticket and cannot be influenced by Pelikán. If the client requests
Pelikán to do the changes, Pelikán will charge a fee according to the
current fee rates in T&C (section G). The client can also request a change
of the ticket directly with the carrier. If the client is abroad and is
interested in changing the return flight, the client can do so by contacting
the nearest branch of the airline. If the client requests Pelikán to make
the changes of a flight you are required to pay all the fees related to this
change to Pelikán no later than the due date stated on the Payment
documentation.
If the client purchased insurance with their plane ticket and they want to
edit it according to the new flight dates, it is necessary to contact our
Customer Service Center and request the change of the Insurance
contract. The updated Insurance contract will not be eligible to claim for
damages that arose from the event which caused a change of their flight
dates. If the current length of their stay in the destination they are flying
to exceeds the length of their original stay, they will most probably need
to pay the difference in price of the insurance. If they do not want to
make changes, the insurance will not be valid for the new, changed days
and flights that were not originally insured.
If the cancellation is made no later than 48 hours prior to the scheduled
departure, it is possible to proceed with the process in accordance with
the official cancellation policy of an airline. If the client requests a
cancellation less than 24 hours prior to the departure or after missing the
flight (so-called, no show), normally, the client can only ask for a refund
of the airport charges. It is the right of the airline to decide whether (or
not) to accept the request for the refund. If the client wants to cancel a
flight ticket of a low-cost airline, you needs to contact the airline directly
and following the terms and conditions of the said airline.
Cancellations can only be made during office hours of Pelikán, based on
the completed and signed cancellation form delivered to Pelikán
Customer Service on time. When cancelling the already issued tickets, in
addition to the non-refundable airfare fee, Pelikán will charge the client
an administrative fee for each ticket according to the current fee rates in
T&C (section G). This fee will be charged even if the ticket is nonrefundable and the airline returns the airport charges.
If the client cancels the flight ticket for flights that have been changed or
cancelled by the aircraft carrier and this change does not suit the client
but, at the same time, the airline offers the client a full refund as one of
the options, Pelikán will not charge the administrative fee for the flight
ticket cancellation. These fees are charged along with the fees set by the
airline.
Any changes to already issued flight tickets or cancellations of the flight
tickets already issued may be requested only by the person whose name
is on them and it can be done only on behalf of themselves. If the

cancellation is requested on behalf of other travel companions or the
cancellation is requested by a person other than the one mentioned in
the previous sentence, this person must confirm in writing that they are
entitled to make such changes or cancellations of the issued flight tickets
on behalf of all mentioned persons for whom the change or cancellation
is requested. This is possible if the person requesting the change or
cancellation on behalf of the travel companions, is their legal
representative or is a person authorized to cancel or make changes to
the flight ticket issued by these persons or the person has the right to
cancel or make changes to the flight ticket on the basis of legal
regulations or other legislation.
If Pelikán has reasonable grounds for suspecting or becomes aware of
the fact that the person referred to in the previous paragraph is
requesting cancellation or changes of the flight ticket and does not have
the documents which would authorize this person to act on behalf of the
person concerned, Pelikán has the right to refuse to cancel or to make
such changes of the ticket of the person concerned. In this case, the
person requesting the cancellation or changes of the flight ticket is
obliged to provide additional documents and information that would
prove that the said person is authorized to make such changes.
If the ticket was a paper flight ticket, the original of the ticket must be
delivered along with the cancellation form. If the original of the paper
flight ticket is not provided, the client is not entitled to any kind of a
refund.
If the reason for cancelling the flight ticket is a serious one (death in the
family, serious health condition, hospitalization), Pelikán recommends
that the client provides also the evidence of the situation given as the
reason for the cancellation (original of the death certificate, medical
report in English, etc.) together with the cancellation form. These
documents, together with their cancellation form will be sent to the
airline which can assess the case individually and refund the client
beyond the official terms and conditions. Pelikán cannot guarantee the
individual (special) procedure in the given cases nor the refund in the
increased amount. If the client does not provide the documents
mentioned above, Pelikán does not guarantee that the airline will be
asked for an individual assessment.
After receiving all the required documents (cancellation form, paper flight
ticket original and, when applicable: a medical report in English, death
certificate), Pelikán and the airline will start the administrative processing
of the request. After the request is processed by the airline, a refund will
be sent to Pelikán or the money will be credited back to a credit card (if
the flight ticket was paid this way). A credit note will be sent to the
client. The time it takes to return the money depends on the actions of
the third party, or more precisely, on the carrier, or let us say, the
supplier. Normally, this process takes approximately 2 months. If the
client requests an individual assessment for serious reasons and provides
the all the necessary document, the cancellation may take several
months.

If a client cancels a ticket that has been paid using a credit card, the
client does not provide the credit card details on the cancellation form.
Depending on the reason of cancellation, Pelikán charges a cancellation
fee based on the current fee rates stated in T&C (section G). The
cancellation fee will be deducted from the amount refunded by the carrier
and reimbursed to the client’s card.
If the client requests to cancel the flight ticket on the day when the ticket
is being issued and files the cancellation form on the same day during
Pelikán office hours, in addition to the ticket issue fee (which is nonrefundable), the administrative fee will be charged per person in
accordance with current fee rates stated in T&C (section G).
Subsequently, the sum in question can be used to buy a new ticket or
this money can be sent back to the client´s account, the processing fee
following the current fee rates stated in T&C (section G) will be deducted.
The client agrees with Pelikán procedures in question.
Reservation for an individual; it is not possible to change the
passenger´s name under any circumstances. It is only possible to create
a new reservation using the current price offer conditions and the current
available flights. A flight ticket issued in the name of a client who cannot
travel can only be cancelled. The cancellation is subject to the conditions
set by the airline for a particular tariff. Exceptions to this are low-cost
airlines which generally allow changes of a name for a fee.

7. For a particular flight, the clients have the option to make a seat
reservation themselves. But not all airlines allow this automatically. If an
airline allows a seat reservation before a flight, it is not applicable to all
flights and tariffs. If it is possible to reserve a seat and the reservation is
successful, after the reservation process is complete, the client can check
the seat reservation at https://www.viewtrip.com/en-US/ViewTrip.asp.
To check the reservation, enter your reservation code into the box
“Reservation number” and your surname (or more precisely, the surname
of the passenger) into the box “Surname.” If it is not possible to make
the seat reservation online or by phone via our Customer Service, the
client can do so only during check-in.

8. The client can also ask for a special meal. Not all airlines offer all
meals offered by Pelikán´s reservation web portal or the web portal of
the business partner providing Pelikán services. The meal the client
chooses will be requested, and if the airline serves this meal on board,
the client´s booking for this service will be confirmed to the client. If the
airline does not serve the type of meal the client requested, the request
will not be confirmed, and the client should contact Customer Service.
After the reservation process is completed, the client can check if the
meal request was confirmed or not, in the latter case, the client will be
informed about the reason why the request was not confirmed. The client
can check the above mentioned here: www.viewtrip.com. To check the

reservation, enter your reservation code into the box “Reservation
number” and your surname (or more precisely, the surname of the
passenger), without diacritics, into the box “Surname.” The information
about whether the meal request was confirmed or not will be available on
this page within 24 hours after making the reservation.

9. Pelikán cannot guarantee confirmation of extra services, such as
animal transport, sports equipment, musical instrument, reserved seat,
special meal, etc., . The client commits themselves to provide all the
documents requested by the airline to confirm the service. If an extra
service has a direct effect on the client´s departure, Pelikán recommends
that the client pays the services after the airline has confirmed that these
are going to be delivered. Pelikán cannot guarantee the price of the extra
services or their confirmation at the time of making the reservation. We
recommend that the client makes sure they have sufficient time to
request, pay and get confirmation for the extra service, and also provide
all the information (service specifications, send completed information
related to the service, paying the fee for the extra service, etc.) at least
72 hours before the service is delivered. If the client pays for the service
and this service is not provided, then cancellation is governed by the
airline's official terms and conditions applicable to the particular
tariff. Pelikán warns its clients that if their ticket includes destination
Botswana, Cameroon, Mozambique, Namibia, Tanzania, South Africa,
Zambia or Zimbabwe, the company does not provide a special service to
transport any weapons.
10. All extra services requested and purchased with an airline, such as
animal transportation, seat reservation, transportation of a musical
instrument or sports gear, extra baggage, etc., are (if you wish to
change or cancel the ticket covering those items) governed by the
general service conditions of that particular air carrier. In this case,
Pelikán assists the client by handling the change/cancellation of the flight
ticket. This process includes managing the impact of such changes on the
delivery of the extra service. However, Pelikán cannot guarantee that
such services are transferred to a different flight, nor does Pelikán
guarantee a refund of extra services if the carrier does not deliver these
because of a change/cancellation by the air carrier. Pelikán is not
responsible for any possible damages caused by not delivering the extra
service by the airline when changing/ cancelling the flight ticket.

11. Flight cancellation and timetable change: An airline has the right to
amend the flight timetable. Pelikán has no influence on such changes in
any way. Pelikán is not responsible for any possible damages caused to
clients by any changes to reservations.
Pelikán can inform the client about a cancellation or a change of a flight
schedule either via e-mail, by phone or by text message (SMS), provided
the client has listed the mobile phone number as the telephone contact.

Text (SMS) notification; please note, it is not possible to reply to these
text messages (SMS). Pelikán will not receive your message. The client
can contact Pelikán via e-mail or by phone using the contact email
addresses and numbers listed on www.pelikan.sk. These contact details
are in the tab “Contacts.” Pelikán does not need to be informed of any
changes to the airline flight schedule that affects a client´s ticket, and
therefore, Pelikán is not responsible for the timing and accuracy of the
information. Pelikán cannot influence these changes in any way, and
therefore, Pelikán is not liable for any damages caused by such changes.
The airline is fully responsible for said issues.
We recommend that the client checks the departure time displayed on
the flight ticket directly with the airline or calls the number of our
Customer Service: +421 2 5464 9494 during office hours. Please check
the departure time 6-24 hours prior to each scheduled departure if the
airline has changed or cancelled any flights.
Outside office hours of our Customer Service, we recommend that clients
check the flights directly with the airline. The client can also check the
reservations and the flight tickets, with the exception of tickets issued by
low-cost airlines, on our web: www.pelikan.sk/kontrola-rezervacie. To
check the reservation, the client enters their reservation code and their
surname, or more precisely, the surname of the passenger (without
diacritics).

12. By providing the data and by completing the reservation, the client
declares that they have read the general commercial terms and
conditions and they understand them and fully agree with them.

ADVICE AND RECOMMENDATION FOR PASSENGERS
Connecting flight(s) in USA
If you change flights and have a connecting flight departing from the
USA, you need to bear in mind that the USA does not have, so called,
transit zones. It means that upon arrival to the USA, each passenger is
required to leave the aircraft, go through immigration control, collect
their luggage, then check the luggage in again and go to the gate for the
connecting flight. Example: VIENNA-FRANKFURT/ FRANKFURT-MIAMI/
MIAMI-MEXICO and back or VIENNA-LONDON/LONDON-NEW YORK/NEW
YORK-SAVANNAH and back, you need to remember that the first
connecting flight is in the USA, passengers are required to go through
immigration control, to collect their luggage and then check the luggage
in again.
On the way back, if the first departure is in the USA (in the example
where the flight departs in Savannah and goes through New York), the

passenger is checked-in for the whole journey, therefore in New York,
the passengers will only transit and will not have to go through any
additional checks.
In the first example, where the return journey begins outside the USA,
and there is a transfer in the USA, the passenger has to do the same as
on the outbound flight, go through immigration control, collect the
luggage and check in the luggage again.
Neither the airline nor our company can influence possible delays you
may incur during immigration checks. If you have flight tickets with
connecting flights, immigration control is taken into account, but delays
caused by unusual situations are not. Therefore, neither the airline nor
our company is responsible for any missed flights or any possible
damages that may occur due to the delays during immigration control
checks.
A transit visa is secured via the electronic form “ESTA”. ESTA is paid by
card.

Connecting flight(s) in Russia
If you decide to make a reservation and purchase a flight ticket to
Belarus And Kazakhstan through Moscow transferring through
Sheremetyevo airport, we would like to draw your attention to the
obligation to get a Russian transit visa.
If you are travelling to other countries with a transfer in Moscow, you
have to get a transit visa. For example, SHEREMETYEVO DOMODEDOVO, or SHEREMETYEVO – VNUKOVO and also when moving
from the arrival terminal to another departure terminal and you leave the
transit area.
For more and detailed information, we recommend that the client reads
the information on the Ministry of Foreign Affairs website, in the section
Travel and Consular Information, where the client can check the selected
country´s more accurate information and about the country´s entry
permit along with the information about visa requirement for the transit
or destination country.`,
        },
        {
          title: "III. General Terms and Conditions for selling low-cost airline flight",
          content: `tickets`,
        },
        {
          title: "I. Definitions",
          content: `1. FLIGHT TICKET – is a contract between a client and an airline for
securing the carriage of a

passenger and their luggage and, if applicable, delivering other services
related to this carriage according to the data on the ticket. By paying for
the ticket, the client automatically and voluntarily agrees with this
contract and its terms and conditions, with the terms of the tariff for
which the ticket was booked, hence with the conditions for cancellation
and possible changes to the ticket. The contract is concluded only after
the ticket is issued/purchased from the airline. The client is informed
about this via e-mail. The current terms and conditions of such a contract
are available on the airline´s website. In relation to this, Pelikán acts
only as a payment intermediary on behalf of the passenger when
arranging the transportation of the passenger and their baggage where
the client pays the total sum for the flight ticket which is then transferred
by Pelikán to the airline whose services the client has chosen. Pelikán is
not responsible for any possible damage caused to the client due to nondelivery of the carrier service caused by the airline or a third party. The
airline is fully responsible for such damages.
2. ELECTRONIC FLIGHT TICKET - is information in the airline
electronic system in which all flight details are safely stored. Clients do
not have to have the electronic flight ticket with them at the check-in at
the airport. However, Pelikán advises clients to have a confirmation of
their electronic flight ticket with them, especially when a client travels to
a country with a visa requirement, or where the length of the visa-free
stay is limited to a particular period. The confirmation of the electronic
ticket purchase will be sent to the client either by Pelikán or directly by
the air carrier.
3. LOW-COST AIRLINE – an airline which offers lower passenger
comfort than conventional air carriers but also, at the same time,
provides lower prices. Such an airline is also called "low-cost carrier" or a
low cost. The basic price of the low-cost flight ticket usually does not
include services such as checked luggage, airport check-in, meals and
drinks on board, etc. Usually, it only provides transport from point A to
point B and does not offer transfer flights where there is an automatic
transfer of a passenger´s luggage from the first flight to a connecting
flight. The ticket reservation is usually not allowed and passengers need
to pay for the ticket immediately when making a booking. Until the ticket
is issued/purchased by Pelikán representative, prices are not guaranteed.
Low-cost airlines are Ryanair, Wizzair, Easyjet, Vueling, Norwegian,
Transavia and many others.
4. CHECK-IN - mandatory passenger check-in for the journey or part
thereof operated by air carriers according to data in the airline ticket. To
check-in, air carriers require valid and up-to-date data from the travel
document used by the passenger. According to the legislation of the final
destination country to which the passenger is travelling, data is required
from an identity card or passport. Check-in can be made electronically or
at the relevant airport. A boarding pass will be issued as a result.
5. ONLINE CHECK-IN – an electronic form of a registration of a
passenger for the journey or a part of the journey. This registration is
made prior to departure. The time by which this registration needs to be
completed is given by the airline. The online check-in (registration) is

usually done online using the website of the airline which operates the
flight that passenger registers for. Online check-in made by a passenger
is typically free of charge. The result of this registration is a boarding
pass (or multiple boarding passes) that must be printed out, and a
passenger must have it with them prior to departure.
6. AIRPORT CHECK-IN – is the registration of a passenger for a
journey or a part of the journey made at an airport a few hours prior to
departure. This registration follows the rules of an airline and is done by
the airline at the check-in desk by the airline´s employee or another
person authorized by the airline. In some cases, this registration can be
made by using a machine located at the designated departure terminal
area. Low-cost airlines usually charge for the airport check-in. The fee
may vary and might be up to € 70 /person/flight depending on the
airline. Airport check-in is free of charge for some flights. The conditions
are set by the low-cost airline.
7. BOARDING PASS – a document issued by the airline (in paper or
electronic form) after completing online check-in or during airport checkin at the airport. It confirms that the passenger is registered (checked in)
for a specific flight and has been assigned a seat on the aircraft. The
boarding pass must always be physically available (in printed or
electronic form) when departing. Without a boarding pass, the passenger
will be denied boarding and the provision of transport services under the
carriage contract.
A boarding pass may also be provided to the passenger electronically via
the airline’s mobile application, and some airlines may require it to be
presented exclusively in this electronic form. The boarding pass usually
indicates the time when boarding begins (“Gate opens”) and the time
when boarding closes (“Gate closes”). After boarding has closed,
passengers who are not yet on board are no longer permitted to enter
the aircraft.
8. FLIGHT TICKET PRICE – the price of selected air carriage services.
The price usually consists of the airfare, airport fees and a service fee
charged by Pelikán. Paying for the ticket is mandatory, and it is a
condition for issuing the flight ticket. The ticket price is paid to Pelkán,
that transfers this amount to airline carrier (after deducting Pelikán
service fee).
9. AIRPORT FEES – fees levied by a city, a state or a country relating to
processing the passenger´s departure, flight change or arrival to a final
destination. Usually, this fee is included in the airfare (or ticket price).
However, in some cases, certain airport fees are paid in local currency in
cash and directly at the airport prior to a return departure. Such fees are
not included in the ticket price when purchased from Pelikán (especially
in the case of flights to some Asian, African and South American
countries.
10. PELIKÁN SERVICE FEE – This represents the fee for facilitating the
client's ticket purchase. It also includes Pelikán's expenses, such as
technology and administration costs related to the ticket purchase
facilitation.

11. GROUP BOOKING - booking with a minimum number of 10
passengers. Due to the higher number of passengers, it is necessary to
check the real availability of flight tickets for this type of tickets. Group
flight ticket distribution may affect the price and availability of tickets. If
you decide to purchase tickets in a split group, you need to create
another order only after you have received the booking code of the
previous one. As the actual availability of tickets for all passengers is not
checked, we cannot guarantee that the price will be the same in the next
booking. If the price/availability changes for a second booking at the
same time, it may not be possible to cancel the first booking.
12. Additional passenger information - APIS (Advance Passenger
Information System)
Based on the national legislation of the countries of the final destination,
some airlines require additional passenger information. This information
has to be added to each passenger´s reservation prior to departure. The
requirements mentioned above may apply to flights to the USA, Canada,
the UK, Qatar, the Russian Federation, etc. The required additional data
are a passport number (or ID card, if applicable), passenger´s
nationality, date of birth, the country of issue and the expiration date of
the travel documents. A passenger must provide this information to the
airline prior to departure. To ensure easy boarding, travelling and
arriving in countries, the information must be accurate and correct.
Passengers are responsible for the accuracy of this information.
The passenger´s information must be provided to the airline or Pelikán.
If Pelikán receives this information, Pelikán will forward this information
to the airline immediately after the ticket having been purchased by a
client. This information needs to be entered into the “Manage my
Booking” section of pelikan.sk at least 3 days prior to departure. If the
ticket is purchased less than 3 days prior to departure, the client is
required to enter these details immediately after receiving the ticket by email to letenky@pelikan.sk. If this information is required to enter the
country of the passenger’s final destination and if the passenger does not
provide the information, check-in will not be possible. We recommend
that passengers enter this information into their reservations as soon as
possible, prior to departure.`,
        },
        {
          title: "II. Conditions and method of booking low-cost airline flight tickets",
          content: `1. Pelikán operates online information system on the web portal www.
pelikan.sk or the web portal of a business partner offering Pelikán
services. Through these portals, a client can search for current flight
connections according to the requirements specified in the booking form
(requirements such as the departure city/country the clients want to fly
from, the date of departure, the return departure place, the date of

departure on the way back, etc.) and also purchase a ticket for the flights
that meet their requirements. It is also possible to book or buy low-cost
flight tickets.
2. The client can view current offers and availability of flight
connections as well as the price of flight tickets 24 hours a day using
online information system. In case of technical issues or outage of the
system or the system of the airline to which Pelikán´s information is
connected; the display of available flight connections may be temporarily
or entirely unavailable. If this happens, Pelikán is not responsible for
damages to the client that arise from the system failure and by the fact
that it was not possible to search for, book or purchase flight tickets.
3. If a client is interested in a non-binding flight offer, they can contact
our Customer Service Agent via the contact form (to be found in Contacts
tab) or the client can contact the Customer Service via email or by phone
calling to one of our Customer Service lines. When the client agrees with
the non-binding offer which is considered as a so-called offline flight
ticket booking, the Customer Service Agent will send a proforma invoice
for the selected products to the client.
4. Pelikán enables clients to pay for low-cost flight tickets which were
booked via an offline booking. In this case, however, Pelikán does not
guarantee the non-binding offer/offline booking price of the selected
flight tickets and services related to these tickets or the availability of the
selected flight tickets on the particular route as there is a chance of
a change in availability of free seats on the selected flights. Hence, the
client is aware of this increased risk of choosing an offline booking and
agrees with this choice. If after the payment of the offline booking, the
selected flight tickets are available at the price paid by the client, Pelikán
will send the flight tickets to the client via e-mail (to the email address
the client indicated in the offline booking). If there is a change in price or
availability of the services, the tickets the client selected may not be
issued by Pelikán. In this case Pelikán will contact the client during
Pelikán´s office hours and inform the client about the situation and offer
alternatives/possible solutions. If any of the offered alternatives is not
suitable to the client, Pelikán will immediately return to the client the full
payment received in the same way as the client used for the payment.
The client is not entitled to claim for damages incurred in connection with
non-issuance of the tickets due to the aforementioned reasons.
5. Before paying for the tickets and other services related to them, the
client must always check if the provided information is correct and
complete. The client must do so in the case of both, online and offline
bookings. We recommend that the client checks the following in
particular:
1) the name and surname in the format indicated in the valid travel
document which will be used for travelling and the gender of all
passengers
2) the place of the departure and return flight as well as possible
connecting flight places

3) date of departure and return flight
4) time of flights including the times of connecting flights (the departure
or arrival time is always the local time of the country of departure/arrival)
5) selected low-cost airline
6) telephone and e-mail contact of a selected passenger
7) the date of birth of all passengers, if applicable
8) other information related to, e.g., luggage included in the ticket for
individual passengers, etc.
9) other services included in the ticket, e.g., travel insurance, etc.
10) information indicated on a valid travel document, if it is required for
a successful reservation or purchase of a ticket
6. It is essential that all the personal information is correct and true. This
information serves to identify the client and their reservation in further
communication. If there are any discrepancies, the client is required to
contact Pelikán, in writing by e-mail or by phone. Possible discrepancies
/errors are for example: incorrect name and surname or gender, name
mistaken for a surname and vice versa or wrong academic title (degree).
If the airline requires additional documents or information (passport
number, national ID card, miles and more card, a copy of national ID
card, copy of passport, credit card number), the client will be informed
about this fact by phone or in writing to the email address the client
provided. By completing the information entry and the booking, the client
is informed about the processing of the personal data provided for issuing
the ticket and the services related to the ticket. If the client provides
false or incomplete information, Pelikán reserves the right to full
compensation for any damages caused by the client´s fault in providing
the false information. In this case, Pelikán is not responsible for damages
that might incur as a result of providing false or incomplete data.
7. If the client decides to buy selected low-cost flight tickets and the
services included, the client will choose one of the available payment
methods and pay for the selected tickets and services at the full price.
8. Low-cost airlines do not usually allow ticket reservation. Therefore, the
condition for a successful purchase of the ticket is the immediate
payment of the full ticket price. The payment is the last step of a
successful online booking.
9. When the payment is successfully credited to Pelikán´s account on
time and immediately after placing the booking, the tickets and services
included in the tickets will be issued/purchased after verifying their
availability with the supplier. When this process is completed, and tickets
are issued/purchased, the tickets will be sent to the client by email to the
address given in the booking. The tickets are sent no later than 14 days
before the scheduled departure.

10. In the event of technical issues or outage that occurred when placing
the online booking on the website of a low-cost airline, or the client fails
to complete the payment for the online booking (as the period for online
payments is limited) or if during the time of placing the booking for the
selected tickets these tickets are sold out at the selected price, or there
is a reasonable suspicion that the card used for the payment is misused,
etc., the tickets and the services related to those tickets may not be
issued/purchased by Pelikán. If this happens, Pelikán will contact the
client as soon as possible and inform them about the situation and offer
them possible solutions and alternatives. If none of the alternatives is
suitable to the client, Pelikán will refund the full amount paid for the
tickets. This amount will be credited back to client's account from which
the client paid for the tickets. The client is not entitled to compensation
for damages incurred in connection with non-issuance of the tickets due
to the above mentioned circumstances.`,
        },
        {
          title: "III. Changes, cancellation, and refund of low-cost flight tickets",
          content: `1. When a flight ticket is issued, all changes pertaining to a low-cost
flight ticket and a cancellation of such ticket are subject to the tariff
conditions set by the low-cost airline for a particular ticket. The client is
obliged to get acquainted with these conditions before the tickets are
purchased and issued. The terms and conditions are also available when
placing an online ticket booking.
2. Although there are some exceptions to this, usually the conditions for
a flight ticket are provided directly by a low-cost airline and in English
only. The terms and conditions are usually not available in other
languages. If the client does not understand the language in which these
are written, or the terms and conditions are not displayed, we advise our
client to contact our Customer Service before purchasing the ticket.
3. The conditions for a change or a cancellation are set for each ticket
separately, and Pelikán cannot influence them in any way. The low-cost
flight tickets are, in principle, not refundable.
4. If a client wants to make changes or to cancel already issued low-cost
flight ticket, the low-cost airline whose ticket the client purchased can
normally manage that or Pelikán can do so, depending on what option
the client chooses. If the client has any doubt or is unsure about
something, the client can contact Pelikán´s Customer Service. Our
agents will verify change and cancellations options.
5. If the change or cancellation of the issued ticket is to be ensured by
Pelikán and concerns only one passenger, only the passenger in question
may apply for such a change or cancellation. If the change or
cancellation is requested by another person or the change or cancellation
affects a number of persons on an airline ticket, any change to tickets
already issued or cancellation of tickets already issued to the persons
concerned may only be requested by the person authorized to make the
change or cancellation due to the fact that he / she is the legal

representative of the persons concerned or is empowered to make such a
change or cancellation of a ticket issued, or the right to make a change
or cancellation of the issued ticket is the result of the labour regulations,
or other legislation. If Pelikán suspects or becomes aware of the fact that
said authorization to make a change or cancellation of the issued ticket
from any person concerned, who is legally entitled to use the ticket and
associated services of a low-cost air carrier, has not been granted to him
/her, Pelikán has the right to refuse to carry out this change or
cancellation of the issued ticket.
6. Pelikán will charge an administrative fee for changes and cancellations
of tickets made upon a client´s request. The administrative fee is
charged according to the current fee rates in T&C (section G).
7. The Pelikán service fee is not refundable when a client requests a
ticket cancellation, and it is not refundable even in the case that the lowcost airline cancels or changes the flights.
8. If a client requests a change of low-cost flight tickets or the client
requests a new flight less than 48 hours before the flight and in the event
that Pelikán can provide such changes, Pelikán will charge a fee
associated with such a change. It is essential that this fee is credited to
Pelikán´s account no later than on the due date specified in the payment
instructions sent by email. If the client fails to pay the fees on time, the
change may not be made by Pelikán. In this case, the client may only
apply to the low-cost air carrier operating the flight for a change - if the
client is not certain that the payment of the charges associated with the
Pelikán change was credited on time, they should request such
information from Pelikán. The Client is not entitled to compensation for
damages incurred in connection with the non-observance of the due date
for making a change in flight tickets.
9. If Pelikán is able to cancel the flight tickets of low-cost airlines and
such cancellation is requested on the basis of a properly filled-in and
signed cancellation form and delivered in a timely manner via e-mail at
letenky@pelikan.sk or in writing to Pribinova 17954/10, 811 09
Bratislava, Slovenská republika, cancellation will be made according to
the conditions of the cancelled flight ticket.
10. If Pelikán is able to cancel the flight tickets for low-cost airlines and
the reason for cancellation is a serious reason (e.g. the death of the
passenger or of a close relative), Pelikán recommends that the client also
delivers the documents mentioned in the cancelled form (officially a
certified copy of the death certificate, a medical report in English, etc.)
together with the cancellation form. These, along with the cancellation
request, will be sent to the low-cost airline who can judge the case
individually and refund the client beyond the official conditions. Pelikán is
not responsible for the individual procedure in the given cases and the
refund of the increased amount. If the client does not provide the
required documents, Pelikán does not guarantee that the airline will be
asked for an individual assessment of the cancellation.

11. After receipt of the complete documentation for the cancellation of
the ticket (cancellation of the form or medical report in English, the death
certificate, etc.), administrative processing will take place within Pelikán
and the low-cost air carrier. The low-cost airline usually refunds the
refunded amount to Pelikán. The client will be sent a credit note via email. The full refund is conditional upon the carrier's processing,
generally lasting approximately 2 months. If the client requests an
individual judgment for serious reasons and provides the necessary
documentation, the cancellation may take several months. Pelikán does
not have the opportunity to influence the length of this process in a
significant way.
12. In the event that the client cancels a flight ticket which has been paid
for with a credit card, the cancellation of the ticket will be processed only
after payment of the relevant cancellation fee by the client of Pelikán
according to the Price list of the General Commercial Terms & Conditions.
13. A low-cost air carrier is entitled to make adjustments to its timetable
on the basis of the transport conditions with which the client was
required to acquaint themselves before payment and issue of the ticket,
however, the low-cost air carrier is obliged to inform passengers of such
changes in a timely manner. In the event that a low-cost airline decides
to change its flight plan and this results in a change in the ticket
purchased by the client, the client is informed either directly by the
carrier or by Pelikán and the alternatives are offered to them. Pelikán
might not be informed of all changes to the low-cost airline's timetable
that impact on specific tickets and is not responsible for the timeliness
and accuracy of the information in these cases. Pelikán cannot influence
these changes in any way and is not responsible for any damages caused
to the client caused by such changes in purchased flight tickets. The lowcost air carrier is fully responsible. Information on the Common Rules of
the Compensation Scheme and assistance to passengers in the event of
denied boarding, in the event of cancellation or long delays established
by the European Parliament and the Council of the European Union can
be obtained on 00 800 67891011 or in several languages here:
https://ec.europa.eu/transport/themes/passengers/air_en

IV Other optional flight ticket services for low cost airline carriers
1. Optional services are additional services related to flights offered by
selected low-cost air carriers and / or any other third party, checked
luggage, choice of preferred seat, priority boarding, assistance for
immobile passengers, transportation of sports equipment, etc. The fee
for providing optional services is not included in the ticket price. Pelikán
cannot guarantee the provision of these services and is not required to
provide provision of such. However, upon individual agreement, it is
possible to provide assistance for the provision of these services for a fee
which will be individually calculated for the client, depending on the
service in question, the low-cost airline, flight dates, destinations, etc.
The Client shall be required to supply all supporting documents requested

by the low-cost air carrier in their own interest in securing an optional
service.
2. Low-cost air carriers generally do not allow the client to request a
special type of food in advance, as the airfare and / or beverages are not
included in the airfare and can only be purchased by the carrier directly
on board a particular flight.
3. Low-cost air carriers do not, in principle, transport animals, with the
exception of assistance dogs and other animals specified by specific
carriers in their transport conditions.
4. We recommend the client to check the departure times of their issued
flight ticket directly at the low-cost airline or by telephone on +421 2
5464 9494 during the opening hours of the Customer service, and that 3
days prior to each scheduled departure in case the carrier changes or
cancels the flights. Outside of the Customer service opening hours, it is
possible to verify flights directly with a particular carrier.`,
        },
        {
          title: "V. Special conditions for the low-cost carrier tickets of Wizzair,",
          content: `Ryanair and Laudamotion
1. In the case of Wizzair low-cost carrier tickets, these conditions have
an application preference in comparison to the other conditions of these
GC. If a certain area is not regulated, the respective general provisions
for the low-cost carrier tickets shall apply, or other respective parts of
these GC.
2. If the client orders Wizzair tickets on-line for two and more persons,
and the date of departure is at least 60 days from the day of the order,
just enter the first and last name of one of the passengers during the
order. But such passengers must be at least 16 years old at the time of
the flight. Apart from luggage, other additional ticket services in such
order can also be included right away. Such as priority boarding and
seating, as well as Premium customer services and ticket insurance. If
the client pays for such order, the order will be completed. The client
must provide the first and last names of the remaining passengers until a
certain period from the successful payment of the order, which is set by
Pelikán. The client is always informed about the period until which they
have to provide the first and last names of the remaining passengers
during the order. By sending the order, they agree with such period. The
ticket price is guaranteed to the client under these conditions. The
insurance contract will be sent to the client once the remaining first and
last names of passengers have been provided.
3. The client can cancel the entire order until the first and last names of
all passengers have been provided, in which case the sum paid for the
order of these tickets will be reduced by the cancellation fee charged by
Pelikán, in accordance with the tariff stated in these GC, and returned to
the client. Within this period, the client can also change the first and last
name of passengers which are already entered in the order, with no
additional fee.

4. If the client does not provide to Pelikán the first and last names of the
remaining passengers within 48 hours from the payment of the ticket
order, Pelikán does not guarantee the ticket price as indicated in the
order; and if the ticket price increases, the client has to either pay the
difference or cancel the tickets, however, in accordance with Pelikán’s
conditions. All additional ticket services and insurance are linked to the
ticket order.
5. Special services (such as transporting pets, musical instruments,
sporting equipment, etc.) can be ordered once the client has provided
the first and last names of all passengers with ordered tickets, and this
information was delivered on time, i.e. within 48 hours from ticket
payment. In the case of late payment, special services can be ordered
once Pelikán has confirmed that the ticket price has not changed, or if
the price of the ordered tickets has increased, once the client has paid
the difference.`,
        },
        {
          title: "IV. General Terms and Conditions for selling Multicity Airline Tickets",
          content: `1. Multicity Airline Tickets – flight tickets marked as "Multicity Airline
Tickets" are a set of multiple individual flight tickets (defined in Part A of
the General Terms and Conditions for flight ticket sales, Art. I.
Definitions), whereby the client concludes individual transport contracts
separately with each of the airlines listed on Multicity Airline Tickets.
Each Multicity Airline Ticket transport contract is governed by the
individual Tariff and Contract Terms of each airline which the Multicity
Airline Ticket includes. Multicity Airline Tickets can include flights such as
low-cost air carriers as well as other classical air carriers, or a
combination thereof. Multicity Airline Tickets are created using a unique
flight combination technology that no ordinary airline offers and they are
always marked as "Multicity Airline Tickets" in the booking.
2. This part of the General Terms and Conditions represents a special
arrangement for the terms of the booking, the sale of the Multicity Airline
Tickets, the rights and obligations of the passengers who bought these
tickets, the after-sales service of Pelikán, changes and cancellation. In
those cases, not governed by these tariff conditions, the other parts of
the General Commercial Terms and Conditions, in particular their
provisions regarding tickets (e.g. Part A, Part E, Part F, etc.), will be
applied accordingly, taking into account the specificity of Multicity Airline
Tickets.
3. The Client acknowledges that the specific contractual terms of a
particular carrier will apply to the contractual relationship between them
and the particular carrier providing the individual flight that is the content
of the Multicity Airline Ticket. It is the passenger's responsibility to get
acquainted with the terms before a contract of carriage between them
and a specific carrier is concluded - Pelikán will provide these conditions.
If Multicity Airline Tickets include flights provided by multiple carriers, the
passenger is required to become acquainted with the conditions of all
carriers which the Multicity Airline Tickets contains.

4. Multicity flight tickets cannot be found online through the search
engine on Pelikan.sk, their booking can only be made offline, through the
Customer Service. However, the offer of Multicity Airline Tickets can be
promoted through the online portal. It is not possible to guarantee the
offer of Multicity Airline Tickets on each of the Client's selected airlines.
The Client can only choose from a range of currently available Multicity
Airline Tickets. On the basis of the booking and payment of the Multicity
Airline Ticket price, the Client asks Pelikán to arrange the conclusion of
the contract of carriage between the passengers shown on the booking
and the selected airlines. Each individual contract of carriage is concluded
by acceptance of the offer for its conclusion on the part of a particular
airline. Due to the nature of the Multicity Airline Tickets and the
combination of flights of multiple airlines that are not interconnected in
the reservation systems, Pelikán reserves the right to change or cancel
the general offer of Multicity Airline Tickets in the event of a change in
the offer on the part of an airline. Pelikán also does not guarantee the
acceptance of an offer for the conclusion of a contract of carriage by
airlines. In such cases, Pelikán informs the Client and attempts to offer
them alternative options. If the Client has paid for the Multicity Airline
Ticket and is not satisfied with any of the offered alternatives, Pelikán will
return the funds to the Client and no sale of the Multicity Airline Ticket
will transpire.
5. Upon successful conclusion of all contracts of carriage that the
Multicity Airline Ticket includes, reservation numbers for each flight ticket
are generated for the Client under which they will be registered with both
the carriers and Pelikán. These booking numbers will be sent to the email address of the Client along with tax document and other documents,
not later than the next working day of the Pelikán Customer Service after
the funds have been credited to the Pelikán account for the Multicity
Airline Ticket booking.
6. The Client is obliged to send Pelikán the so-called APIS data (see
definition in Part A, Article I, point 10 of these General Terms and
Conditions) for each passenger on Multicity Airline Tickets, at least 3
days prior to departure. If Multicity Airline Tickets are purchased less
than 3 days prior to departure, the Client is obliged to send this
information by e-mail to Pelikán immediately upon receipt of the
reservation numbers of the individual tickets.
7. In the case of flight tickets for which the airport check-in is linked with
a charge, Pelikán will send the boarding passes by e-mail no later than
12 hours prior to each departure to the Client so that the Client can print
them out for all passengers so they may present them at the airport. If
the airline does not charge for airport check-in for a particular ticket,
Pelikán will send an electronic flight ticket to the client at the same time,
this is, however, not a boarding pass and the passengers must check-in
for the flights in question at the airport. If the Client fails to send Pelikán
full and correct APIS data for all passengers in time, Pelikán will not only
be unable to provide online check-in, which may involve airport check-in
charges, there is also the risk that the airline may refuse boarding the
aircraft to passengers without an alternate flight or refund and, in

addition, it will cancel some or all of the rest of Multicity Airline Tickets,
without refund of the unused flights or compensation thereof.
8. As all Multicity Airline Tickets form several separate contracts of
carriage with different airlines and different content, in the event of
interest in changing or cancelling specific flights, each contract is
governed by its own terms of reference, depending on the airline and the
terms of its tariff class. In case of doubt, the Client can contact Pelikán
who will verify the required change (flight time / date of flight /
destination / name / passenger / class, etc.) and its feasibility together
with the change fee. In the event of a change in the Multicity Airline
Ticket made at the Client's request, Pelikán will charge a fee according to
the rates specified in Section G of these General Terms and Conditions.
Similarly, the Client can approach Pelikán if they wish to cancel any or all
of the Multicity flights, and Pelikán, in accordance with the conditions of
the airline, verifies what amount will be refunded in the event of a
cancellation. In the event of a cancellation of Multicity Airline Tickets at
the Client's request, Pelikán will charge a fee according to the rates
specified in Section G of these General Terms and Conditions.
9. The dimensions, weight and number of items and type of luggage
included in individual contracts of carriage that make up Multicity Airline
Tickets may vary, and the Client is required to respect the conditions of
individual airlines including overweight / dimensions / number of pieces
or type of baggage. Any air carrier that provides a flight covered by
Multicity Airline Tickets may charge additional service charges not
included in the Client's prepaid cost of the contract of carriage, which, in
addition to the luggage, is selection of preferred seating, refreshment,
and so on. These services are optional and are therefore not part of the
price paid by Multicity Airline Ticket passengers. It is not guaranteed that
each airline permits the provision of the required additional service upon
the passenger's request. We recommend that you request the addition of
these services in advance, no later than 72 hours prior to the departure
to which the Client wishes to add the optional service. If an optional
service is requested later, it may not be processed by our service in time
and it will only be possible to request the service at the airport prior to
departure, where, if it is accepted by the relevant airline must be paid
for. Passengers must be aware that besides the basic price of a Multicity
Airline Ticket to the relevant destination, it does not include any
additional charges that a passenger may incur during the journey to the
destination (in particular airport transfers, visa fees, charges for above
standard services, etc.).
10. In some cases of interconnected flights which are included in Multicity
Airline Tickets, the carriage to the destination is ensured by the fact that
for each individual flight on the route to the destination of each direction,
the passenger receives a boarding pass which is otherwise constituted as
a separate ticket. In such a case, the Client acknowledges that:
(a) each individual part of the journey (each individual flight) may be
subject to different rules, in particular if it is implemented by another
selected carrier;

(b) if passengers wish not to use one of the individual Multicity Airline
Ticket flights, they may normally use the other flights without additional
charges and fines. However, this option may not apply to classical (nonlow cost) air carriers that have multiple flights covered by Multicity Airline
Tickets. In the event that a passenger plans not to use one of the
Multicity Airline Ticket flights, they are required to verify the possible use
of the Multicity Airline Ticket flights with Pelikán, otherwise the airline
may cancel some or all of the remaining flights on the Multicity Airline
Tickets, without the right to a refund of unused flights or compensation;
c) when transferring between flights, it is usually necessary to collect the
checked baggage and once more check it in at the respective counter for
the next flight, due to the fact that use of Multicity Airline Ticket flights is
generally not an ordinary transfer flight but the use of a separate new
flight, in some cases also with another selected carrier. We therefore
recommend that you first verify in advance with Pelikán if there is the
obligation to collect luggage for individual flights on Multicity Airline
Tickets.
11. Within the cooperation with the company APRA, s.r.o. (hereinafter
the „APRA“), the company Pelikán offers services of the aforementioned
company to Multicity tickets, in the form of expert assistance in obtaining
of the compensation from the airline operator in case where the client is
entitled to a claim according to the Regulation of the European
Parliament and of the Council No. 261/2004, as amended (hereinafter
the "Regulation 261/2004"), in case of flight delays, cancellation,
redirection, incorrect transfer of the passenger to the lower flight class,
etc. Each client who purchases Multicity tickets is automatically entitled
for the APRA assistance, if any situation, which is, according to the
Regulation 261/2004, associated with the claim for compensation of the
client as a passenger. It is up to the Client whether he/she will use the
services of APRA, if such a situation occurs, and grant the company APRA
with the power of attorney regarding this matter. If the client decides to
use APRA’s services, the contractual relationship is governed by the
General Terms and Conditions of APRA. Should APRA’s conditions be
contrary to Pelikán's GTC, Pelikán's GTC prevail in such area of
application. If the APRA fails to recover the Client's claims, the Client
shall not pay for services, because in such situation the services are
provided without eligibility for a processing fee. APRA shall deduct its
processing fee, which represents 20% of the total amount of
compensation recovered, from the total amount recovered only if the
recovery of claims for the client has been successful.`,
        },
        {
          title: "V. General Terms and Conditions for the Sale of Combined Tickets",
          content: `1. Combined Tickets - a set of several separate tickets (further defined in
Part A of the General Terms and Conditions for the Sale of Flight Tickets,
Article I Definitions), which is not labelled as “Multicity Tickets" and which
constitutes a single journey, wherein the client concludes individual
transportation contracts with each of the airline companies listed on the
tickets separately. Each transportation contract contained in the

Combined Tickets is governed by its own tariff and contractual terms and
conditions of the individual airlines whose flights these tickets include.
They may include both flights of low-cost air carriers as well as others,
the so-called classic air carriers, or a combination thereof. Combined
tickets are created using unique technology combining flights that
conventional airlines do not offer.
2. This Part of the GBT&C represents a special regulation of the terms
and conditions for ordering, sale of Combined Tickets, rights and
obligations of passengers who bought these tickets, after-sales service of
Pelican, changes and cancellation. In the cases, which are not regulated
by these Tariff Terms and Conditions, the other Sections of the General
Business Terms and Conditions, in particular their provisions concerning
freight tickets (e.g. Part A, Part E, Part F, etc.) shall apply, mutatis
mutandis, given the specificities of these tickets.
3. The Client acknowledges that, for the contractual relationship between
them and the particular carrier providing an individual flight which is
contained in these tickets, the specific contractual terms and conditions
of the particular carrier will apply. It is the responsibility of the passenger
to become acquainted with them before a transportation contract is
concluded between them and the particular carrier – Pelican will provide
them with those terms and conditions. In the event that these tickets
contain flights operated by several carriers, the passenger is obliged to
consult the conditions of all carriers whose flights contain tickets.
4. Combination Tickets can be searched online through a search engine
on the Pelikan.sk portal through a standard search engine on the
homepage and calendars in the section Cheap Flight Tickets. It is not
possible to guarantee the offer of Combined Tickets for each airline
connection chosen by the client. The client can only choose from the offer
of currently available Combined Tickets. On the basis of the order and
payment of the price of these tickets, the client asks Pelican to mediate
the conclusion of a transportation contract between the passengers
specified in the order and the selected airlines. Each individual
transportation contract is only concluded after the acceptance of the offer
for its conclusion by the particular airline. Given the nature of these
freight tickets and the combination of flights of several airlines not linked
to each other in the reservation systems, Pelican reserves the right to
change or cancel the general offer of these tickets in the event of a
change of the offer on the part of an airline. In addition, Pelican does not
guarantee the acceptance of an offer to conclude a transportation
contract by airlines. In such cases, Pelican shall inform the client and try
to offer alternative options. If the client has paid the price of those
tickets and none of the alternative options offered is suitable for them,
Pelikán will reimburse the funds to the client which theypaid and the
purchase of Combined tickets will not be completed.
5. After the successful conclusion of all transportation contracts, covered
by the Combined Tickets, the reservation numbers of individual tickets
will be generated for the client, under which they will be recorded by

both air carriers and Pelican. The client will receive these reservation
numbers at their email address as part of the tax document and e-ticket,
along with other documents.
6. To Combined Tickets, the client has the option to choose the Premium
Assistance Service including the following additional services related to
the air transportation ordered:
a) Prolonged Customer Service contact time using the Call button (for
more details, see Part D, Art. IX. paragraph 1, sub-paragraph (a));
b) 100% discount on the Pelican service fee for online check-in, if it is
allowed on the given flight by the airline company (for more details, see
Part D, Art. IX. paragraph 1, sub-paragraph (c)).
7. If the client has ordered the Combined Tickets, the additional service
called Premium Assistance Services, they are obliged to send to Pelikán
the so-called APIS data (see definition in Part A, Art. I, point 11 of these
GBT&C) for each passenger on these tickets at least 3 days prior to
departure. In the event that the tickets are purchased less than 3 days
prior to departure, the client is obliged to send this information to Pelican
immediately after receiving the reservation numbers of individual tickets
by e-mail. In the case of air tickets for which the airport check-in would
be subject to a charge, Pelican will send boarding passes to the client by
e-mail so that the client can print them out for all passengers at least 12
hours before each departure and show them at the airport. If the airline
does not charge airport check-in for particular tickets, Pelican will send
electronic tickets to the client within the same time period; however,
they are not boarding passes and the passengers shall check-in for the
relevant flights at the airport. The Client is obliged to send the APIS data
to Pelican even if the Combined Tickets contain a flight other than a lowcost carrier flight. If the client fails to send the complete and correct APIS
data of all the passengers to Pelican in time, it will not only be impossible
for Pelican to carry out an online check-in on their behalf, which may
involve charging airport check-in, but also runs the risk that passengers
will be denied boarding without providing a replacement flight or refund
and, in addition, will cancel part or all of the rest of the flights covered by
the tickets, without entitlement to claim a refund of unused flights or
compensation for damage.
8. Since all Combined Tickets are made up of several separate
transportation contracts with different airlines and different content, in
the case of an interest in a change or cancellation of particular flights,
each contract is governed by its terms and conditions, depending on the
airline and the terms and conditions of its tariff class. In case of doubt,
the client can contact Pelican which will then verify the feasibility of the
change requested by the client (flight time/flight date/destination/name
or surname of the passenger/class, etc.) along with the amount of the
fee for the change requested. In the case of a change of airline tickets on
the basis of a client's request, Pelican will charge a fee according to the
Tariff of Fees stated in Part G of these GBT&C. The client may also
contact Pelican if they wish to cancel some or all of the flights, and
Pelican will verify the amount of the refund in the case of flight

cancellation, according to the terms and conditions of the airlines. In the
case of cancellations of airline tickets on the basis of a client's request,
Pelican will charge a fee according to the Tariff of Fees stated in Part G of
these GBT&C. In the event of cancellation/change of any of the flights
covered by the Combined Tickets, Pelican will endeavour to provide the
client with a suitable alternative option of transportation. If the client
does not agree with it and wants to cancel the remaining ticket(s)
because the Combined Tickets consist of several separate transportation
contracts, the remainder of the journey will only be refunded according
to the terms and conditions of the individual air carriers operating the
remaining flights, even if the cancellation/change was made due to the
reason on the part of an air carrier.
9. The dimensions, weight and number of items and the type of baggage
covered by the individual transportation contracts that make up the
Combined Tickets may vary, and the Client is obliged to respect the
terms and conditions of each airline, including charges for exceeding the
weight/size/number of items or type of baggage. When ordering and
upon completion of the order, Pelican always states the strictest
conditions for the transportation of baggage, valid for any of the flights
covered by the tickets selected by the client. Each air carrier that
operates flights covered by these tickets may charge fees for additional
services that are not included in the price of the transportation contract
paid by the client, in addition to luggage, e.g. selection of preferred
seating, refreshment, etc. These services are complementary and
optional and, therefore, do not form part of the basic price paid by the
passenger for the tickets. It is not guaranteed that each airline permits
the provision of the required additional service at the passenger's
request. We recommend requesting the addition of these services well in
advance, at least 72 hours before departure of the flight, to which the
client wishes to add an optional service. If the client requests an optional
service later, their request might not be processed in time by Pelican and
they will only be able to request the service at the airport prior to
departure, where they will be obliged to pay for it if it is accepted by the
airline concerned. The passenger acknowledges that the price of the
Combined Tickets does not include, in addition to the basic price of all
thetickets to the final destination, any additional charges that may be
incurred by the passenger during transportation to the final destination
(in particular fees for transfer in airports, fees for visas, fees for extra
premium services, etc.).
10. In some cases of connecting flights which are contained in the
Combined Ticket, the transportation to the final destination is ensured by
obtaining a boarding pass for each individual flight to the final destination
of each direction, which otherwise constitutes a separate ticket. In this
case, the client acknowledges that:
a) each individual part of the journey (each individual flight) may be
subject to different rules, in particular if it is performed by another
selected carrier;
b) if a passenger wishes not to use any of the individual flights included
on the tickets, they may, as a rule, use the other flights without

additional charges and penalties. However, this option may not apply to
traditional (non-low-cost) air carriers that have multiple flights covered
by the tickets. If a passenger does not plan to use any of the flights
covered by the Combined Tickets, they are obliged to check with Pelican
regarding the availability of other flights; otherwise, the airline might
cancel some or all of the remaining flights covered by the tickets, without
entitlement to claim a refund of the unused flights or compensation for
damage;
c) when transferring between individual flights, it is generally necessary
to pick up checked baggage and have it checked back on the appropriate
counter for the next flight, as the flights covered by these tickets are not,
as a general rule, a simple connecting flight, but rather a separate new
flight, in some cases also using another selected air carrier. Therefore,
we recommend verifying the obligation to pick up baggage for individual
flights in advance with Pelican.`,
        },
        {
          title: "VI. Flight tickets partially or fully paid by voucher for a cancelled",
          content: `flight
This part of the GTC represents a special arrangement of the terms and
conditions related to the order and the sale of flight tickets that were
fully or partially paid by the Voucher for a cancelled flight. In cases not
governed by these terms and conditions, other provisions of the GTC in
Part A will be applied accordingly. General terms and conditions for the
sale of flight tickets.
In order to use the Voucher for a cancelled flight (specified in more detail
in Part D VIII and Point 2 of these GTC**), Pelikán provides the
possibility to place an order for the flights of an airline company for which
the Voucher for the cancelled flight is intended, by means of the pelikan.
sk portal.
The specific terms and conditions and possibilities of using the Voucher
for a cancelled flight are related to the terms and conditions set by the
airline company for the purchase of the products for which the Voucher is
intended.
The client places the order in a standard way and, when placing the order
for specific flights, the client has the use of conditions for transport, the
so-called rules. If in the case of payment with the Voucher for a cancelled
flight the conditions of transport vary from the ones the client had when
placing his order, Pelikán will send to the client’s e-mail address the new
conditions of transport valid for the flight ticket selected. If you are
interested in more detailed information about the conditions of transport
in relation to the payment with the Voucher for cancelled flight, please
contact our customer service.
Unless the reservation of the products stated in the order is confirmed at
the time of placing the order after selecting payment with the Voucher
for a cancelled flight as a payment method, the client’s request for the

order of products will be individually reviewed by the airline company
before purchasing the services and products ordered, in order to ensure
compliance with the terms and conditions of using the Voucher for a
cancelled flight.
If the client changes the method of payment to a payment using the
Voucher for a cancelled flight after he/she has sent his/her confirmation
of reservation, such reservation of products stated in the order can be
additionally cancelled.
After the client’s request and the conditions of using the Voucher for a
cancelled flight have been reviewed, Pelikán will send to the client’s email
the conditions for transport valid for the flight ticket paid partially or fully
by the Voucher for a cancelled flight. The Voucher for a cancelled flight
cannot be used to pay a service fee or other fee of Pelikán, nor for travel
insurance, etc. After the payment using the Voucher for a cancelled flight
has been deducted, the client will be informed on the amount of an
additional fee for payment using other available payment method
(specified in more detail in Part E II, Point 1 of these GTC).
In the event that the client agrees to the conditions for transport, Pelikán
will make every possible effort to ensure the products and services
ordered by the client. The contract is concluded after a flight ticket of a
specific air carrier has been issued/bought, of which the client is informed
through electronic mail. The current terms and conditions of the Contract
can be found directly on the website of a specific carrier. In principle,
Pelikán acts within this process as a paying agency only, whereby the
client hands over to Pelikán the total purchase price of the flight ticket,
and subsequently Pelikán pays the price to the carrier whose services the
client has chosen. Pelikán is not liable for possible damages caused to the
client due to the failure to provide transport, caused by the airline
company or another party. It is the airline company as an air carrier who
is fully responsible for it.
If the client does not agree to the current conditions for transport, the
fully paid amount will be refunded to the client using the method of
payment selected by the client.
Neither the conclusion of a transport contract related to the selected
flight nor its price, which may change, is guaranteed to the client before
the moment when a confirmation of the purchase of a flight ticket is sent.`,
        },
      ],
    },
    {
      title: "B. GENERAL CONTRACT TERMS AND CONDITIONS FOR SALE OF CK PELIKÁN",
      content: `PACKAGE TOURS`,
      subsections: [
        {
          title: "I. Definitions",
          content: `1. TO – Travel Office
2.

2. TO Pelikán – business company pelicantravel.com s.r.o., travel
office with its seat at Pribinova 17954/10, 811 09 Bratislava,
Slovenská republika, C ID#: 35 897 821, the company is registered
in the Commercial register maintained at the Municipal Court
Bratislava III, sec.: Sro, insert #. 32895/B
3. Traveler - a natural person who concludes a tour contract, or to
whom tourist services should be provided based on the concluded
tour contract. All persons on the traveler's side are obliged to fulfill
their obligations arising from the tour contract in conjunctim et
divisim (jointly and severally).
4. Law on Tours - Act No. 170/2018 Coll. On tours, related tourism
services, certain conditions of tourism business, and amendments to
certain laws.
5. Tour contract - duly concluded contract between the Travel Office
and the Traveler, the purpose of which is to arrange a tour for an
agreed price. As a tour contract properly concluded by the traveler
within the meaning of the preceding sentence shall also be deemed
a tour contract duly completed and signed by his/her legal or
authorized representative. These General Terms and Conditions and
all written documents and information received by the Traveler or
based on which the traveler enters into a contract, including more
detailed information about the tour, stay or ordered services, the
information contained in the website www.pelikan.sk, form the part
of the tour contract.`,
        },
        {
          title: "II. Preamble",
          content: `1. The Travel Office Pelikán operates on the website https://www.
pelikan.sk/en/deals/list an information system which provides
information on selected currently available tourism
services. Services, which, within the meaning of the Law on Tours,
are considered as tours or associated services, are subject to the
General Business Terms and Conditions for the sale of tours and
associated tourism services.
2. Information on travel services and their combinations is provided by
individual tourism service providers (carriers, airlines,
accommodation facilities, other travel agencies, etc.). This
information shall include, but is not limited to, price information,
available capacities and available classes. The TO Pelikán provides
information as it was obtained from individual providers; it takes
responsibility for correctness of the data only for tours which it
procures on its own.
3. Information on services and their combinations is continually
updated, usually several times a day during the opening hours of
the TO Pelikán. At the time of the last update, some information
may be, e.g., about the availability of service - i.e. about free seats
in the means of transport, free rooms in the hotel of relevant price
category, not up to date and changed.

4.

4. Combinations of services are intended for direct sales and are sold
as they are offered, i.e. it is not possible to book individual partial
tourism services (transport, accommodation, etc.) which form part
of a combination of services.
5. For tours, which the TO Pelikán offers as so-called commissioned
dealer, i.e. it acts as an agent for sale of products and services of
other travel agencies, informs the traveler, that it is a tour
purchased by another travel agency with which the traveler shall
conclude a tour contract. The tour contract is therefore concluded
between the Traveler and the Travel Agency, which is not the TO
Pelikán. The liability for products and services, as well as compliance
with the legal obligations of the tour operator is born in such cases
by the Travel Agency, whose products and services are involved,
and the tour contract is also governed by its General Terms and
Conditions, which are outside the control of the TO Pelikán.
6. A person who acts on behalf of the Traveler or as a Traveler, by
signing the contract confirms that he/she has an authority provided
by law or by a mandate to enter into this contract on behalf of the
Traveler, and in case of the conclusion of a contract on behalf of the
other person, such person has expressed his/her consent to the
participation in the tour. Such a person represents that he/she has
available consent to the processing of personal data of that person
and that he/she has informed him/her about the terms of data
processing according to this contract. All communication needed to
fulfill a tour contract will be conducted with the person who acts on
behalf of the Traveler or acts as a Traveler herself/himself.`,
        },
        {
          title: "III. Ordering of the tour",
          content: `1. The Traveler may order the tour as follows:
a) by completing and submitting the ordering, so-called „on-line“, form at
the website: pelikan.sk;
b) by sending an email with a binding order for a particular selected tour
to the email address pobyty@pelikan.sk;
c) by submitting of a binding order for a particular selected tour by phone
at +421232166321; or
d) in person at the registered office of the TO Pelikán
2. The TO Pelikán shall confirm the receipt of order by an e-mail sent to
the contact address indicated in the order, and reminds the Traveler
about meeting the conditions for concluding of a Tour contract, unless
these have been already met. It also informs the Traveler about the
creation of the Order management at the website www.pelikan.sk, where

the Traveler can check the order and where important documents are
stored.
3. By submitting the order, the Applicant declares and confirms that:
a) he/she become acquainted and agrees with the General Terms and
Conditions of the TO Pelikán;
b) he/she become acquainted and agrees with the Terms and Conditions
of individual tourism services providers, in particular transport,
accommodation providers;
c) he/she meets the conditions for taking part in the tour; and
d) he/she become acquainted and agrees with the processing of the
personal data, provision of which is necessary for the conclusion of the
Contract, and with the provision thereof to the providers of individual
tourism services within the extent necessary for the procurement and
provision of such services.
4. The Traveler is responsible for the completeness and correctness of
the information provided in the order. The same applies to the
information about other travelers on behalf of whom the Contract is to be
concluded.
5. TO Pelikán reserves the right to refuse the order if it contains obvious
misstatements, erroneous or incomplete information, and the Traveler
does not remove the discrepancies even within an additional period of
time.
6. Execution of the order is considered as a proposal of the Traveler for
the conclusion of a Tour Contract, the subject of which is the ordered
Tour.`,
        },
        {
          title: "IV. Tour Contract",
          content: `1. The Tour Contract is established by accepting the Traveler's proposal
for the conclusion of the Tour Contract with the TO Pelikán.
2. The TO Pelikán shall accept the contract proposal at the latest on the
next working day following the day on which the conditions for the
conclusion of the Tour Contract have been met from the Traveler side.
3. The TO Pelikán shall accept the contract proposal, if the following
conditions are cumulatively met:
a) the Traveler has provided all necessary information for the conclusion
of the Tour Contract and for the procurement of each of the services that
are part of the Tour;

b) the Traveler agreed with the contents of the General Terms and
Conditions of the TO Pelikán and the terms and conditions of the tourism
service providers applicable to the services that are part of the Tour; and
c) the traveler must pay a prepayment amounting to 100% of the tour
price within the deadlines and using the methods specified in the
received order and in accordance with the instructions provided by TO
Pelikán in the order confirmation.
4. The TO Pelikán may accept the contract proposal even if the condition
in paragraph 3 (c) of this Article is not fulfilled, in the case it has agreed
with the Traveler on a different period and/or method of payment for the
Tour price.
5. The date of payment shall mean the date of crediting funds to the
account of the TO Pelikán. If the funds are credited to the account of the
TO Pelikán after the end of its opening hours, which is indicated at its
website www.pelikan.sk, the next business day is considered as the
payment day. If, due to the Client's incorrect indication or failure to
provide indication of the payment, it is not possible to identify the
payment correctly, as the crediting time is considered the time when the
payment has been correctly identified.
6. The TO Pelikán will not enter into a Tour contract with the Traveler if:
a) the Traveler fails to meet the conditions for the conclusion of the Tour
Contract in accordance with paragraph 3; or
b) the conditions are met when the Tour at the required price level
chosen by the Traveler is sold out.
7. If the Tour Contract is not established, the TO Pelikán shall inform the
Traveler as soon as possible of this fact and shall return to the Traveler
received financial means related to the accepted order without undue
delay, unless otherwise agreed.
8. The TO Pelikán shall send to the Traveler at the latest by the end of
the following working day following the conclusion of the Tour Contract,
also the following documents:
a) confirmation on the Tour Contract conclusion;
b) other relevant information on the Tour;
c) the invoice.
9. Also other relevant documents and records stored in the Order
Management, from where they can be downloaded, will be available to
the Traveler, about the availability of which the Traveler shall be
informed by e-mail.
10. Documents entitling the Traveler to receive purchased services
included in the Tour (ticket, accommodation voucher, etc.) shall be made

available to the Traveler by the TO Pelikán no later than 7 days before
the start of the Tour.
11. Should the Contract is concluded less than 7 days before the start of
the Tour, the TO Pelikán shall make available to the Client the documents
referred to in points 8 and 9 of this Article without undue delay after the
conclusion of the Contract.
12. The Traveler is obliged in particular:
a) to provide the TO Pelikán the necessary co-operation for the ensuring
and proper provision of the services, in particular to truthfully,
completely and correctly provide the data required by the Tour Contract
and without undue delay notify it of any changes to these data;
b) to submit, or deliver to the TO Pelikán the required documents
necessary for ensuring of the proper provision of ordered services;
c) check the correctness of the data provided in the documents entitling
to the provision of services according to the Tour Contract or in
connection with the Tour Contract; and
d) appear in time for the provision of services as directed by the TO
Pelikán.
13. In case of breach of any obligation under the Article IV, par. 12 of
this part of the GTC, the Traveler is obliged to pay the TO Pelikán an
amount specified by the service provider's Terms and the TO Pelikán's
service fee for the modification of the data, within the specified period of
time. If there is a change in data pursuant to Art. IV, par. 12 (a) after
the order has been sent by the Traveler, and they need to be corrected
or supplemented so that the provider of the services, which are part of
the Tour, does not, in accordance with the applicable Terms, deny the
provision of the services to the Traveler, the TO Pelikán shall ensure that
these changes are executed, based on the Traveler's notification and
after the payment of the costs of such changes by the Traveler.`,
        },
        {
          title: "V. Price, price change, payment terms",
          content: `1. The price of the Tour (hereinafter referred to as the "Tour price")
means the total price of the Tour indicated in the Tour Contract. The
Parties acknowledge that the Tour price may additionally include costs
and fees that can not be determined before the conclusion Tour Contract,
the fact of which the Traveler is informed in advance.
2. For the application of children's discount, the decisive is the child's age
as of the last day of the Tour, or as of the end date of provision of
services.

3. The Traveler's right for the provision of all services ordered is
established only after the payment of the full price of the Tour and after
other conditions for the provision of services are met.
4. The date of payment shall be considered the date when funds were
credited to the account of the TO Pelikán.
5. Pelikán Travel Agency (TO Pelikán), if acting as the tour organizer, has
the right to require full payment (100%) of the package tour price (all
ordered services) at the time of contract conclusion. Alternatively, a
deposit of at least 34% of the total price of the tour (all ordered services)
may be requested, depending on the total order price and the number of
days remaining until the start of the package tour services. The balance
payment (hereinafter referred to as "balance payment") covering the full
cost of the booked tour or all ordered services (if only a deposit was
paid) must be paid by the traveler (the purchaser) no later than 35 days
before the start of the tour or the commencement of services. The
amount and due date of the balance payment will be individually agreed
upon with the traveler before concluding the contract and will be stated
in the proforma invoice and final invoice. Instructions regarding payment
methods and deadlines will also be found in the order confirmation and
order management details.
Certain services in the order may require full payment upfront, meaning
the client must pay for them in full on the day the order is placed. The
amount paid will then be proportionally applied toward covering the
remaining services in the order.
The tour price is indivisible among travelers and constitutes their shared
obligation. If the total price of the tour has not been paid in full, no
individual traveler has the right to partial fulfillment.
By paying the deposit, the traveler commits to paying the full price for
the ordered services and agrees to the terms for paying the balance
amount. Cancellation fees, contractual penalties, and claims for
compensation are payable immediately.
If the traveler fails to pay the balance on time, TO Pelikán reserves the
right to cancel the ordered services. In such cases, the deposit along with
any partial payments made are non-refundable, and the traveler is not
entitled to a refund of the already paid funds.
The traveler is entitled to receive services only after full payment of the
package tour price. If the traveler fails to comply with the agreed
payment deadlines and amounts for any reason, TO Pelikán reserves the
right to refuse the provision of services. If the traveler does not make the
payments within the due dates specified in the tour contract or fails to
pay the full tour price, TO Pelikán will consider this as a withdrawal from
the tour contract under Article X, Section 1, with the traveler being
obligated to pay a cancellation fee as stated in Article X, Section 3.

In the case of cancellation insurance with one of the insurance products
from the European Travel Insurance Company, coverage can be utilized
even after the first payment of the agreed amount has been made.
However, insurance claims can only be submitted based on the amount
already paid by the client for the insured services, minus the cost of the
insurance products.
6. The Parties have agreed that the TO Pelikán is entitled to unilaterally
increase the cost of the Tour as a direct consequence of the changes
relating to:
a) the cost of transport of Travelers resulting from changes in fuel or
other energy prices, in which case the cost of the Tour will be increased
by the value of the increase in the price of the transport when compared
to the price of the transport on the starting day of the Tour,
b) the amount of taxes or fees for tourism services included in the Tour
charged by a third person who is not a direct provider of the tourism
services included in the Tour, including a local tax on accommodation,
airport charges and port or entry or exit fees at the airports and ports,
where the price of the Tour will be increased by the value of the increase
of these taxes and fees, comparing the amount of these taxes and fees
on the date of the conclusion of the our Contract with the respective
amount on the starting day of the Tour, or
c) exchange rates of the currencies related to the Tour, in which case the
cost of the Tour will be increased by the value of the exchange rate of
such currency against the EUR, when comparing the value of this rate on
the date of the Tour contract conclusion with the value of exchange rate
on the starting date of the Tour.
7. The Parties have agreed that the Traveler is entitled to a Tour price
discount corresponding to the reduction in the costs referred to in
paragraph 5 of this Article, which occurred since the conclusion of the
Tour Contract until the starting date of the Tour.
8. A clear and comprehensible notification on an increase in the cost of
the Tour, together with the justification and calculation of the Tour price
increase, must be sent to the Traveler no later than 20 days before the
starting date of the Tour, otherwise the TO Pelikán will not be entitled to
receive a payment of the difference in the price of the Tour. The Traveler
is obliged to pay the difference without undue delay, not later than within
the time period specified in the notice of the increase of the price of the
Tour, otherwise the TO Pelikán is entitled to proceed according to par. 3
of this Article.
9. If, according to this Article, the increase in the price of a Tour exceeds
8% of the cost of the Tour, the Parties shall proceed in accordance with
the Art. VIII, par. 1 (b).

10. The TO Pelikán is not obliged to return the paid Tour price if the
passenger did not take part in the Tour for reasons beyond the control of
the TO Pelikán.`,
        },
        {
          title: "VI. Rights and obligations of the traveler",
          content: `1. The basic rights of the Traveler include:
a) the right to the proper provision of fully paid Tour and services.
b) the right for a proper provision of information about the Tour and the
ordered services, already known to the TO Pelikán, as well as for
information about the changes that the TO Pelikán has learned later,
when the price of the Tour has been already paid. The information
obligation within the meaning of the Act is in any way affected.
c) the right to withdraw from the Contract at any time and without giving
any reason prior to the start of service provision, subject to the
conditions according to the Art. XI. of this GTC.
d) Prior to the starting date of the Tour, the Traveler may notify the TO
Pelikán that another person, who meets all agreed conditions for
participating in the Tour and agrees with the assigning to the Tour, will
take part in the Tour in his/her place. The change of the Traveler is
effective for the TO Pelikán, if the notification of the assignment of the
Tour Contract according to the first sentence is delivered to the TO
Pelikán within a reasonable time period, but not later than 7 days before
the start of the Tour. The original Traveler and the new Traveler are
jointly and severally liable for the payment of the remainder of the Tour
price and any fees, surcharges and other costs incurred in relation to the
change of the Traveler and about which the TO Pelikán has notified them.
Fees, surcharges and other costs according to the preceding sentence
shall not be disproportionate and may not exceed the actual costs
incurred by the TO Pelikán as a result of the assignment of the Tour
contract. The TO Pelikán shall be obliged to prove to the new Traveler,
upon request, the incurrence of additional fees, surcharges or other costs
as a result of the assignment of the Tour contract. By the assignment of
the Tour contract the new Traveler agrees with the concluded Tour
Contract. After the agreement on the joint and several liability of the
original and the new Traveler for the payment of the Tour price has been
reached, the TO Pelikán is entitled to proceed according to the Art. V.
par. 3, in case the price of the Tour is not paid.
e) The right to claim deficiencies and failures in the provision of services
in accordance with the Art. XI. of these GTC and the enforcement of
claims according to the Art. XI. of this GTC.
f) The right to contact a representative of the TO Pelikán, whom the
Traveler may contact in case of troubles during the whole Tour with a
request for assistance and who is also entitled to receive and handle

complaints. The Traveler declares, in the case of provision of personal
data of another natural person, that he/she has available the consent of
that person, which is able to prove at any time at the request of the TO
Pelikán, and that he/she has informed person in question about the
terms of personal data processing by the TO Pelikán.

2. The principal responsibilities of the Traveler include in particular to:
a) Provide the TO Pelikán with the cooperation necessary to ensure a
proper provision of the Tour and ordered services, in particular the
provision of complete and truthful data for the purposes of the Tour
contract and other necessary documents, as well as the provision of all
relevant documents and details, which are a prerequisite for the provision
of services. In case of failure to comply with this obligation, the Traveler
shall be liable to pay the TO Pelikán all costs and damages incurred by
the TO Pelikán due to provision of incorrect and incomplete data.
b) Notify the TO Pelikán in advance on the provision of services to
persons other than nationals of the Slovak Republic, otherwise, the TO
Pelikán shall not be responsible for the proper provision of the Tour or for
the provision of services to these persons. Other persons than nationals
of the Slovak Republic are themselves responsible for meeting all the
necessary requirements (such as passports, customs, foreign exchange
and other Tour country-specific travel regulations), which are a
prerequisite for the provision of the Tour and services for them.
c) Pay the full price of the Tour for all ordered and Tour-related services
within the meaning of Art. V. of this GTC, and if necessary, to prove this
fact;
d) In case of received notification on additional changes regarding the
Tour or the ordered services, the Traveler is obliged to communicate his
/her position without undue delay within a specified time period to the TO
Pelikán.
e) Accept from the TO Pelikán all the documents necessary for the
provision of the ordered and paid services and to check the correctness
of the data contained therein and, if he/she discovers an inaccuracy in it,
then he/she is obliged to inform the TO Pelikán without undue delay.
f) During the provision of services, follow the instructions and information
notified by the TO Pelikán or by its agents as well as the instructions of
the direct service providers, adhere to the times and places of departure
and on their own responsibility ensure all the necessary travel documents
and fulfillment of other conditions necessary for the provision of services
(passport, visas, insurance papers, vaccinations, etc.).
g) Follow the instructions of the TO Pelikán as well as the instructions of
the direct service providers and follow the scheduled Tour program and
the relevant laws of the visited country, as well as the place and the
facility of the stay; in case of their violation or serious breach of the Tour

program or the provision of services, the TO Pelikán is entitled to deny
their provision to the Traveler, thereby forfeiting their right to these and
other unused services, without the right to a refund the paid Tour price.
h) Bear their own responsibility and to compensate for any damage
caused by their actions during a Tour or provision of services in a means
of transport, accommodation facility or caused to other person.
i) Ensure that the persons under 15 are accompanied and supervised by
an adult participant in the Tour during the whole Tour, similarly to ensure
the accompaniment and the necessary supervision of persons whose
health or personal condition requires so.
j) Respect safety regulations and instructions related to the safety of
transport, as well as to follow the instructions of the on-board airline
personnel, respect smoking ban on board the aircraft, do not behave
aggressively against traveling passengers, etc. Failure to comply with the
obligations set out in the preceding sentence excludes any liability of the
TO Pelikán for non-participation of the Traveler in the Tour or for the
inability to properly use the ordered services.`,
        },
        {
          title: "VII. Obligations of the TO Pelikán",
          content: `1. The principal responsibilities of the TO Pelikán include in particular:
a) provide the Traveler with a name, place of stay or contact address and
a phone contact to its representative.
b) Obligation of the insurance contract concluded for the whole period of
Tour sales, providing protection in case of bankruptcy.
2. The TO Pelikán is not responsible for the level of those services the
Traveler orders himself/herself from third parties. The amount of
damages as well as all other claims related to the air transport that is
part of the provided services (loss, damage, late arrival of the baggage,
delays in flight, change of flight time, etc.) is governed by the relevant
regulations applicable to the air transport.`,
        },
        {
          title: "VIII. Change in agreed services before starting a Tour",
          content: `1. The parties agree that the TO Pelikán is entitled to change the terms
of the Tour contract prior to the start of the Tour, if it is a minor change
and the TO Pelikán shall inform the Traveler about the change. As a
minor change to the terms of the Tour is considered the change in the
place and accommodation facility, if the alternative accommodation of at
least the same or higher category is provided and in a similar area,
change in the order of places visited, change in the transport due to

changes in transport, safety or other operational grounds, change in the
place of departure and arrival, if the free transport is provided from and
to the original place.
2. If the TO Pelikán is forced to significantly change one of the key
features of the tourism services mentioned in the Article 14 par. 2 (a) of
the Act, or is not able to meet the special requirements according to the
Article 16 par. 4 (a) of the Act or proposes to increase the cost of the
Tour by more than 8%, it shall propose to the Traveler the amendment
of the Tour contract. In such a case, the TO Pelikán shall immediately
inform the Traveler in a clear, comprehensible and a certain way about
a) the proposed changes and their impact on the cost of the Tour,
b) the Traveler's right to accept the proposed changes within a specified
reasonable time or withdraw from the Tour contract without payment of
the compensation,
c) the fact, that if the Traveler does not accept the proposed changes to
the Tour contract according to the point (ii) within the specified time
period, the Travel contract will expire; and
d) the price of an alternative Tour if such alternative Tour is offered to
the Traveler.

If the Traveler withdraws from the Tour contract and does not accept an
offer of alternative Tour, the TO Pelikán is obliged to return to the
Traveler all payments made by the Traveler or on behalf of the Traveler
without undue delay, no later than 14 days from the date of delivery of
the withdrawal notice.`,
        },
        {
          title: "IX. Change in agreed services after starting a Tour",
          content: `1. The TO Pelikán is authorized to make immediate changes to the
program of the Tour and the provided services if, for objective reasons,
due to force majeure, decisions of the Government and other competent
authorities or exceptional circumstances, which are beyond the control of
the TO Pelikán, the original tour program and services can not be
ensured; in such case the TO Pelikán is obliged to:
a) provide an alternative program and services within the scope and
quality that is the most comparable and relevant to the nature of the
original services, and if the service provided is at least of the same level
(e.g. an alternative accommodation in a hotel of the same or higher
category), all other claims of the Traveler are excluded, or
b) refund the Traveler with the price paid for the not provided or by
alternative provision of services uncompensated services, or

c) provide the Traveler with a discount on the price already paid for
services which have not been provided in full extent, or for which no
substitute performance was provided; or
d) provide the Traveler with assistance without undue delay, or
e) ensure other Traveler's rights under the law.
2. The Travel Office is not responsible for the consequences of changed
or non-provided services or program caused by an event that could not
be avoided even with all efforts or due to unusual and unforeseeable
circumstances (e.g. due to a delay of means of transport caused by
technical failures, weather conditions, traffic conditions, the carrier's
decisions, strike and similar circumstances beyond the control of the TO
Pelikán). The Travel Office is also not liable for the consequences of
changed or not provided services or programme caused by a change or
cancellation of the services by the passenger by means other than
through the Travel Office, either with the service provider or through
third parties.
3. The Traveler acknowledges that for services, which includes
accommodation, is the first and last day intended particularly for the
transport and transfer, hence the claims relating to shortening the length
of stay for that reason shall be considered as unfounded.`,
        },
        {
          title: "X. Withdrawal from the tour contract by the traveler and the",
          content: `compensation
1. Travelers have the right to withdraw from the Tour contract at any
time prior to the start of the Tour, and for such case the Parties have
agreed upon a compensation payment, the amount of which takes into
account the time before the start of the Tour, the expected reduction in
costs due to the unexploited tourist services by the Traveler forming
Tour, and the expected income from the alternative sales of tourism
services.
2. Amount of compensation (amounts quoted are for one person without
age difference):
a) costs actually incurred, at least €40/traveler + 20% of the Tour price,
if the Traveler withdraws from the Tour contract within 90 days or more
before the start of the Tour,
b) costs actually incurred, at least €40/traveler + 50% of the Tour price,
if the Traveler withdraws from the Tour contract within 89-30 days before
the start of the Tour,
c) costs actually incurred, at least €40/traveler + 75% of the Tour price,
if the Traveler withdraws from the Tour contract within 29-15 days before
the start of the Tour,

d) 100% of the Tour price, if the Traveler withdraws from the Tour
contract within 14 days or less before the start of the Tour,
3. If the Traveler fails to take part in the Tour or does not start to use
the provided services for any reason, or he/she does not use the services
at all or in part due to his/her own decision, he/she is not entitled to a
refund for the unused services.
4. If the Traveler requires a change in date or accommodation under the
original contract according to new conditions, if the TO Pelikán is able to
ensure such change, the proceedings shall be the same as with a
withdrawal from the contract, subject to the conditions of compensation
payments under this Article, unless otherwise agreed.
5. The TO Pelikán may withdraw from the Tour contract before start of
the Tour without the obligation to compensate the Traveler for the
damage caused by such withdrawal, exclusively if
a) the number of participants in the Tour is less than the minimum
number of participants required under the Tour contract and the Travel
Office withdraws from the Tour contract within the period specified in the
Tour contract, but at the latest
* 20 days before the start of the Tour, if it is a journey that lasts longer
than 6 days,
* 7 days before the start of the Tour, if it is a journey that lasts from 2
days to 6 days,
* 48 hours before the start of the Tour, if it is a journey that lasts less
than 2 days, or
b) unavoidable and exceptional circumstances prevent the TO Pelikán to
comply with the Tour contract and the TO Pelikán notified the Traveler
about the withdrawal from the Tour contract immediately before the start
of the Tour.`,
        },
        {
          title: "XI. Complaint procedure, responsibility for the provision of the tour,",
          content: `compensation for damages
1. The TO Pelikán shall be liable for the breaching the Tour contract,
even when other providers of tourist services are obliged to provide
services provided within the Tour (hereinafter "breaching of the Tour
contract"),.
2. If any tourist service is not provided in accordance with the Tour
contract, law or special regulation, or if it does not have the features,
which the Traveler may legitimately expect with regard to the offer and
the usual practice, the Traveler is obliged to notify about such facts
without undue delay the TO Pelikán or its authorized representative.

3. The TO Pelikán is obliged, within a reasonable period of time specified
by the Traveler, to provide a remedy by bringing the tourist service into
compliance with the Tour contract, with the Act or special regulation or
the with reasonable expectations of the Traveler, if this is possible in
given circumstances, or if it does not incur disproportionate costs for the
TO Pelikán with regard to the extent of the Tour contract breach and the
value of the tourism services concerned.
4. Determination of the period referred to in paragraph 3 of this Article is
not necessary, if the Travel Office has notified the Traveler that it shall
not provide a remedy, or if the remedy can not be delayed in view of the
special interest of the Traveler.
5. If the TO Pelikán fails to provide a remedy in accordance with the
paragraph 3 of this Article, it shall offer to the Traveler alternative tourist
services even if the Traveler's return to the place of departure is not
covered by the Tour contract, while these alternative tourism services
must be
a) of the same or higher quality as the services specified in the Tour
contract, without any additional cost to the Traveler, or
b) of a lower quality than the services indicated in the Tour contract, with
the offer of a reasonable discount on the price of these tourism services.
6. Travelers may refuse to accept alternative tourism services offered by
the Travel Office in accordance with the paragraph 5 of this Article, if the
alternative tourism services are not comparable to the tourist services
indicated in the Tour contract or the offered discount from the Tour price
for lower quality of tourism services is not adequate. If the Traveler
refuses the provision of alternative tourist services in accordance with the
first sentence of this paragraph, or if such alternative tourist services can
not be accepted for objective reasons, the Traveler shall continue to use
the tourist services covered by the notification referred to in the
paragraph 2 of this Article, and the TO Pelikán shall provide the Traveler
with a reasonable discount from the price of the tourist services referred
to in the notification according to the paragraph 2 of this Article.
7. If the TO Pelikán fails to provide a remedy in accordance with the
paragraph 3 of this Article, nor provides the traveler with alternative
tourism services pursuant to paragraph 5 of this Article, the Travelers
shall have the right to
a) make the remedy themselves and claims from the TO Pelikán the
reimbursement of costs associated with it,
b) withdraw from the Tour contract without payment of the compensation
and to claim a reasonable discount on the cost of the tourist services
which have not been provided properly and in time, if they represent a
substantial breach of the Tour contract.
8. The Traveler has the right to apply for claims related to the Tour
within two years from the end of the Tour or, if the Tour has not taken

place, since the day the Tour was due to end in accordance with the Tour
contract.
9. The travelers are entitled to a reasonable discount under paragraphs 5
(b), 6 or 7 of this Article. If the TO Pelikán fails to prove that the Traveler
has breached the Tour contract, the TO Pelikán shall be obliged to return
to the Traveler within 30 days from the date filing claims the part of the
price according to the first sentence, taking into account the materiality
and duration of the Tour contract breach; this does not create a prejudice
to the Traveler's right to claim damages.
10. If the transport of the Traveler is also part of the Tour, the TO
Pelikán, in the cases according to paragraphs 6 and 7 (b) of this Article,
shall ensure the repatriation by a comparable transport, without undue
delay and without additional costs to the Traveler.
11. If, as a result of unavoidable and extraordinary circumstances, it is
not possible to ensure the return of the Traveler according to the Tour
contract, the TO Pelikán will cover the cost of the necessary
accommodation, of the same category and class if possible, for a
maximum of three nights per Traveler. Where longer travel time limits,
laid down by specific regulations on passenger rights, are applicable to
the relevant means of transport, the longer time limits shall apply.
12. The limitation of accommodation costs according to the paragraph 11
of this Article shall not apply to persons with reduced mobility and
persons accompanying them, pregnant women, unaccompanied minors
or persons in need of special medical care, if the TO Pelikán has been
informed of their special needs for at least 48 hours before starting a
Tour.
13. The TO Pelikán may not rely on unavoidable and extraordinary
circumstances for the purpose of the limitation of the liability to pay the
costs of the accommodation according to the paragraph 11 of this Article,
if the relevant transport provider is not able to do so.
14. The Traveler is entitled to deliver a report, application, claim, or
complaint (hereinafter referred to as "a complaint") concerning the
provision of a Tour directly to the Travel Agency through which he/she
purchased the Tour. The Travel Agency is obliged to forward the received
complaint immediately to the appropriate Travel Office without undue
delay. The date of the complaint receipt by the Travel Agency shall be
deemed the date of delivery to the Travel Office.
15. The TO Pelikán shall be obliged to provide reasonable assistance to a
Traveler in troubles without undue delay, even in the circumstances
referred to in the Article 22, par. 12 of the Act, in particular by providing
a) appropriate information on health care services, local authorities and
the representative office of the Slovak Republic,
b) the assistance to the Traveler in communication and finding an
alternative solution for the problem.

If the Traveler finds himself/herself in troubles due to his/her intentional
conduct or negligence, the TO Pelikán is entitled to claim compensation
from the Traveler for the assistance provided. The amount of
compensation may not exceed the actual costs incurred by TO Pelikán in
providing assistance to the client.
16. In dealing with the claims according to this Article, the Traveler is
required to provide the TO Pelikán with maximum cooperation in order to
eliminate the deficiencies as effectively as possible and to prevent any
claims or damage from occurring or to reduce their extent.
17. The Traveler has the right to adequate compensation for the property
damage and also the right to adequate non-material damage resulting
from a substantial breach of the Tour contract for which the TO Pelikán is
liable.
18. The TO Pelikán may be relieved of the liability for damage only if it
proves that the breach of the Tour contract has been caused by
a) the Traveler,
b) the third party, who is not the provider of the tourist services provided
within the Tour, if the breach could not have been foreseen or prevented,
or
c) unavoidable and extraordinary circumstances.
19. If an international treaty binding the European Union limits the
extent of the compensation of damages or the conditions according to
which the provider of tourism services provided within the Tour contract
shall pay such damages, the same limitations apply to the TO Pelikán. If
an international treaty not binding the European Union limits the
damages to be paid by the service provider, the same limitations apply to
the TO Pelikán.
20. The Contracting Parties have agreed that the amount of damages
according to this Article may not exceed three times the total cost of the
Tour. The agreement in the preceding sentence does not apply to injury,
deliberate damage or damage caused by a negligence.
21. The right to compensation or to a reasonable discount shall not affect
the rights of clients under specific rules. Compensation for damages or a
reasonable discount by law shall be deducted from the compensation for
damages or reduction of the price under specific rules. The fulfilment of
TO Pelikán shall be reduced by the fulfilment under Specific Rules.`,
        },
        {
          title: "XII. Final provisions, combined tourism services and bankruptcy",
          content: `protection
1. The validity of these Terms and Conditions applies to Tours and
services provided by the TO Pelikán.

2. The communication between TO Pelikán and the Traveler will be
provided exclusively by e-mail to the email addresses indicated in the
Tour order or by phone. The Traveler's important documents are stored
in the Order Management, which is made available by creating an
exclusive user account.
3. By the conclusion of the Tour contract the Traveler confirms that he
/she is acquainted with its content, as well as with all its integral parts
and agrees with it without any reservations. The Traveler also confirms
that he/she is acquainted with the content of the General Terms and
Conditions and accepts the arrangements contained therein.
4. If, following the selection of one of the tourist service and the payment
for it, the Client shall book additional tourist services through the TO
Pelikán, which relate to his/her travel or holiday, they will not be entitled
to the rights, which apply to Tours under the Act No. 170/2018 Coll. On
tours, related tourism services, certain conditions of tourism business,
and amendments to certain laws (hereinafter referred to as "Act No. 170
/2018 Coll. “).
5. Therefore, the TO Pelikán, as the Travel Office, will not be responsible
for the proper provision of the separate tourism services. In any
problems contact your relevant service provider.
6. However, if additional tourist services are booked by the Client during
the same visit to the TO Pelikán or during the same contact with the TO
Pelikán, these tourism services will become part of the combined tourism
service. The TO Pelikán, as the ´Travel Office has, according to the Act
No. 170/2018 Coll. implemented the protection for the purpose of
refunding Clients the payments for services that have not been
performed due to the bankruptcy of the TO Pelikán. Such protection does
not imply a refund in case of the bankruptcy of the relevant service
provider.
7. The TO Pelikán declares that it has complied with its obligations to
ensure protection in the event of bankruptcy and has entered into a
contract providing a protection in case of bankruptcy with the bankruptcy
protection provider "Generali Poisťovňa a.s.", branch of the European
Travel Insurance Company, C ID#: 35 709 332, Lamačská cesta 3 / A,
841 04 Bratislava, Phone: +421 2 544 177 04, e-mail: info@europska.sk
(hereinafter the "bankruptcy protection provider"). If the provision of
services is refused due to the bankruptcy of the TO Pelikán, the Travelers
may contact this entity. This bankruptcy protection does not apply to the
contracts with other parties than the Travel Office, which can be
performed despite our bankruptcy.`,
        },
      ],
    },
    {
      title: "C. GENERAL CONTRACTUAL CONDITIONS FOR SALE OF ACCOMMODATION",
      content: `I.

C.`,
      subsections: [
        {
          title: "I. Introductory provisions and definition of terms",
          content: `1. This part of the General Terms and Conditions governs the relationship
between the client and Pelikán, which arise in connection with the
provision / mediation of accommodation in accommodation facilities of
any category and class.
2. The term "Booking" means booking or reservation of accommodation
for 9 or fewer persons.
3. The term "Group Booking" means booking or reservation of
accommodation for 10 or more persons.`,
        },
        {
          title: "II. How to make a booking and payments",
          content: `1. Pelikán on the portal www.pelikan.sk offers accommodation services,
which the client has the opportunity to search according to the entered
requirements in the booking form (place of stay, arrival date, departure
date, etc.) and at the same time to make a binding reservation on the
appropriate and selected term of the accommodation (hereinafter
referred to as the "Booking"). Pelikán can verify the accuracy of the
information given by the client in the Booking by phone or e-mail. We
strongly advise the client to check the booking in the confirmation sent
and in case of any discrepancies contact Pelikán in writing by email or by
phone. An incorrect name, surname or gender is also considered to be an
irregularity. In the event that the client does not check the accuracy of
the Booking, Pelikán is not responsible for any damages that the client
may incur for that reason.
2. Each Booking by the client shall be considered as an offer to conclude
a contract under these General Commercial Terms and Conditions, with
which the client has agreed.
3. Upon confirmation of the Booking, Payment Details are created and
sent to the client, on the basis of which the client is obliged to pay the
Booking according to the instructions. The price of accommodation is not
guaranteed to the client until the booking is confirmed by the
accommodation provider. In the event that the client does not pay the
full amount in the time specified in the Payment Details by the due date
and under Part E of Article II, paragraph 2 of these Conditions, the
client's Booking will be automatically revoked by Pelikán without any
right to make a claim by the client for damages.
4. If the accommodation selected by the passenger in the required price
level is sold out, the Booking will not be confirmed. Pelikán informs the
passenger of this fact as soon as possible and returns to the client
without undue delay the received financial performance in the same form
as the Booking itself, unless otherwise agreed.
5. In the event of interest in a Group Booking (usually at least 9 - 15
people - depends on the specific accommodation facility), the client is

required to contact Pelikán to familiarize themselves with the specific
terms and conditions relating to such a request. If the client attempts to
bypass the Group Booking by dividing the group into multiple Bookings
so that each Booking covers 9 or fewer persons, the hotel is entitled to
charge the client for a group cancellation fee or other charge for which
the client is responsible, including higher rates at the cost of
accommodation; for the payment of these fees by the service provider
Pelikán bears no responsibility. Pelikán is entitled to cancel Bookings that
attempt to bypass Group Bookings. The fact as to whether the Group
Booking is circumvented or not is the exclusive consideration of Pelikán.
A request for a Group Booking can be sent by email to pobyty@pelikan.sk
by the client. The service provider or the hotel may, in the case of a
Group Booking, require a longer cancellation or payment of the Booking
in advance.
6. Only well-intentioned reservations will be considered as the Booking of
the client. If there is a reasonable suspicion that some Bookings were
made in the interest of occupying and holding multiple free dates to the
same client, and with respect to the client's chosen combination in
Bookings, it is not physically possible for the client to use all of them,
Pelikán first notifies the client of this fact and in the event that the client
fails to remedy the situation by the designated time, Pelikán reserves the
right to cancel the Bookings in question.
7. The client is responsible for the accuracy of all data provided to
Pelikán. The client undertakes to pay all fees incurred in the event of
incorrect data being provided. Titles, name, dates of birth of the children
must be the same as those entered in the passport and / or the personal
ID card. In case the data in the Booking confirmation is not correct, the
client undertakes to immediately inform Pelikán.`,
        },
        {
          title: "III. Voucher",
          content: `1. Pelikán will issue a voucher to the client, which contains a reservation
number. In the event that the client cancels the Booking, the mandatory
voucher issued for the accommodation that was cancelled must be
returned to Pelikán. If the client does not return such a voucher, they are
responsible for its use or misuse.
2. Pelikán invoices the client for the number of nights listed in the
vouchers or on the Payment Details for payment to Pelikán's business
partner (whichever document shows the higher number of nights)
regardless of the number of nights actually used by the client. The client
is required to inform Pelikán by telephone or by e-mail about the
conditions of payment for only the nights actually used. If a client leaves
the hotel earlier, some hotels, especially in the USA and Canada, charge
the price for all nights booked or an additional fixed fee for the number of
nights actually used. In Booking to avoid any dispute about fees, the
client is obliged to provide the hotel with a written confirmation of the
date and time of departure if the client leaves the hotel before the date
stated on the confirmed Booking.

3. In addition to the details of the stay, the name of the local
representative and the reference number of the representative may be
included on the voucher.
4. For hotels in the USA / Canada, if the Booking covers more than one
room and if the travellers have different names, all traveller names must
be printed on the travel note. Names like "TBA" or "X and group" will not
be accepted. If travellers arrive at different times, each traveller must
have their own voucher. Travellers may be charged directly by the hotel
unless the traveller has a voucher for the Booking.
5. If the traveller does not submit a valid voucher at the hotel reception,
the hotel may charge the accommodation and the fees directly to the
traveller.`,
        },
        {
          title: "IV. Information",
          content: `1. Pelikán, in cooperation with its partners, will make every effort to
provide only correct information and reports about the hotels. Pelikán is
not responsible for any damage if it is proven that the information or
reports about hotels are incorrect or incomplete.`,
        },
        {
          title: "V. Responsibility",
          content: `1. In the provision of accommodation Pelikán acts and performs
exclusively as an intermediary. For this reason, Pelikán is not liable for
personal injury, illness, property damage, any other loss, any expenses
incurred directly or indirectly due to the hotel or other service provider
providing or performing the service booked through pelikan.sk.
2. In exceptional cases, the selected hotel is not able to accept a
confirmed Booking. Pelikán will always make every effort to prevent the
situations mentioned in the previous sentence. When such a situation
occurs, Pelikán will seek another suitable alternative solution to provide
the client with accommodation of at least the same standard and with the
most similar location as the accommodation booked on the basis of the
Booking. If, despite the efforts made, Pelikán cannot provide the client
with an alternative accommodation according to the previous sentence,
but the client agrees to a lower quality accommodation, the client is
entitled to a reasonable discount on the accommodation price. If the
client does not agree to a lower quality accommodation, they have the
right to withdraw from the contract and all paid funds for the
Accommodation booking will be refunded to them.
3. Pelikán hereby declares that any hotel accommodation ratings (e.g.
the hotel's star rating) were not carried out and may not be in
accordance with the Decree of the Ministry of Economy of the Slovak

Republic no. 419/2001 Coll., which regulates the categorization of
accommodation facilities and classification signs for their inclusion in
classes.`,
        },
        {
          title: "VI. Hotel reservations",
          content: `1. An additional hotel requirement, e.g. neighbouring or interconnected,
smoking and non-smoking rooms will be accepted, but Pelikán cannot
guarantee their fulfilment. Rooms for disabled people are usually secured
with wheelchair access but are not necessarily equipped with elements
for the seriously disabled.
2. If the client requests an additional night at a hotel on an already
confirmed Booking, the client is obliged to modify the original Booking
and not to book additional nights as a new item.
3. From time to time, there may be renovation work taking place in a
hotel, and the hotel will take all available steps to minimize the nuisance
to its guests. If a hotel carries out renovation during the stay of its
guests, the client is not entitled to claim the refund of the Booking's
price, and any complaints by the client will therefore not be accepted.
4. If Pelikán is specifically informed about the renovation work, this
information will be provided to the client. The client acknowledges that
information about hotel renovation can be changed, and Pelikán may not
always be informed about these changes. Pelikán is not responsible for
any complaints relating to renovation work that are not consistent with
the information provided to Pelikán.
5. In most hotels it is possible to check-in at 02:00 p.m., but in some
countries especially in the USA it can be later than 04:00 p.m. Pelikán
can only guarantee the first night of the Booking (unless otherwise stated
at the time of confirmation); hotels are entitled to free up rooms (cancel
reservations) if the client does not check-in prior to 05:00 a.m. (local
time) of the day following the day they should have arrived.
6. Triple and quadruple rooms can include one double bed and one extra
bed or two double beds. In some hotels, all triple rooms are made up of
one double bed and one single bed. Most hotels do not have a full-size
bed for each guest in the triple and quadruple rooms. If the client
requires an extra bed, the hotel may charge an additional fee, which the
client will pay directly to the hotel.
7. In the USA and Canada, double rooms are defined by the number of
visitors and not the type of bed (e.g. if the double room is confirmed, the
hotel can provide a double room with one bed as two persons sleeping
together). In the Booking, the client may request separate beds, but
Pelikán cannot guarantee this. Triple and quadruple rooms are not
comprised of separate beds, they usually have two separate beds. Most

hotels cannot add an extra bed to the room so that the room becomes a
triple or quadruple room but allow for an extra fee payable directly to the
hotel using a pull-out bed.
8. It is not permitted to make the Booking under a fictitious name with
the aim of facilitating the client to hold a room. If the client does not
complete the Booking under the correct name, the client may be charged
for non-use of the service.
9. Some hotels have different rates for using the hotel only during the
day. Such a hotel can be identified by the phrase "Day Let" or "DayUse"
in the name of the hotel. Rates for using a hotel only during the day will
not be used for Bookings for night-time accommodation and do not
include breakfast. The hotel may charge the client at the correct rate if
the client stays longer than the hotel's terms of hotel use only during the
day.`,
        },
        {
          title: "VII. Tariffs and fees",
          content: `1. All rates quoted on the Payment Details are per room (with private
bathroom or shower unless stated otherwise), including breakfast (unless
otherwise stated), service charge, and state tax.
2. The prices listed in Pelikán's price list valid during a Special Period
(specified in X.1 of these General Commercial Terms and Conditions) are
replaced by prices outside the Special Period.
3. If the client is interested in booking a room with an extra bed for a
child, Pelikán recommends choosing a triple room. In this case, a bed for
the child will be charged at a rate equal to that for a bed in a room with
three adults. The price for two adults and one child is only possible if an
extra bed for a child is added to the double room rate. A child’s bed can
be used if the child is older than 2 years and younger than 12 years of
age (unless another age interval is specified). A bed for a child will not be
available if the age of the child is not specified at the time of the
Booking, and Pelikán will charge the price for three adults in a triple
room. A baby cot is only suitable for children under 2 years of age.
4. An extra bed or bed linen cannot be provided in some hotels and the
child is accommodated free of charge or at a reduced rate. In this case,
the breakfast for the child will be charged by the hotel and the client is
required to pay for breakfast at the hotel upon departure. If the client
requests a bed for a child, the client is required to request a triple room,
with the discount for the child not being provided in this case.
5. In the event that a hotel charges an energy or recreational fee, the
guest is required to pay the hotel directly.
6. In the event that a hotel charges a local telephone charge (allowing
guests to make unlimited local calls from their rooms), the guest is
required to pay such a fee when leaving the hotel.

7. Any support activities that include accommodation free of charge or at
a discounted price in case of accommodation for a specified period do not
apply during the Special Period.
8. Some hotels have floating public prices that change every day. Pelikán
will not refund the funds nor accept as a reason for non-payment the fact
that Pelikán rates are almost the same or higher than the hotel's public
prices.
9. To cover incidental charges, most hotels require the client to provide a
credit card upon arrival. If the client does not have a credit card, the
hotel may require a cash deposit from the client. All additional costs
incurred by the client must be paid directly to the hotel directly before
departure. Pelikán is not responsible for any charges charged by the
hotel personally to the guest.
10. Contracts between hotels and service providers are concluded for the
purpose of providing accommodation for recreational purposes. If at the
time of arrival, it is discovered that a guest is from a company, and the
company has already concluded a corporate agreement with the hotel,
the hotel or service provider is entitled to charge the full cost of
accommodation to the client under a contract between the hotel and the
respective company. Pelikán, or, the supplier of services or the hotel is
not liable if the client does not receive the discounted price of
accommodation under a special contract between the hotel and the
company.`,
        },
        {
          title: "VIII. Country specific information",
          content: `1. Hotels in North America only accept guests older than 21 years unless
accompanied by an adult.
2. Ryokans are Japanese traditional style hotels based on traditional
architecture. Observance of local Japanese habits (such as wearing a
Kimono and not wearing footwear) is an obligation; the food is Japanese
and staff have poor language skills in addition to Japanese.
3. When visiting Russia, tourists are obliged to pay tourist tax upon
arrival at their first hotel.`,
        },
        {
          title: "IX. Special periods",
          content: `1. Specific periods include, for example, the period during which a trade
fair or period of religious package tours, New Year, major sports events,
etc. are held at or near the accommodation. (hereinafter "Special
Periods"). During Special Periods, prices offered by the Pelikán
reservation system may be higher than the hotel's published prices.

2. Additional hotel charges during Special Periods may be notified at the
time of confirmation of the Booking. In such a case, the client may be
notified of the date by which the Booking may be cancelled. If the client
does not cancel the Booking in a timely manner, they are obliged to pay
all fees according to these conditions.
3. Some hotels will not accept changes to the Booking if the Booking
during a Special Period has already been confirmed. Pelikán will ensure
the client be made aware of this fact.
4. Some hotels during trade fairs require reservation of accommodation
throughout the entire duration of the trade fair. The client will be notified
of this fact at the time of the Booking. In the case of a Booking of
accommodation for the duration of a trade fair, a re-confirmation of the
Booking may be required by the client. In case of re-confirmation of the
Booking by the client, the client is obliged to pay the price of the
accommodation for the whole period of the trade fair without any refund,
even if the client so requests to cancel the reservation.`,
        },
        {
          title: "X. Booking cancellations",
          content: `1. In the event that the client cancels the Booking, Pelikán shall send the
client a confirmation of their cancellation. The client is required to inform
Pelikán of not accepting this confirmation, otherwise the client may be
charged for non-use of the service.
2. The client shall be liable to pay to Pelikán any losses, costs, damages,
charges and expenses incurred by Pelikán as a consequence of the
cancellation of the Booking made by the client, including the
administrative and / or processing fee referred to in paragraph 2 of
Article II, Part E of these Conditions.
3. The paid / unpaid Booking for the Special Period cannot be cancelled
free of charge or changed after it has been created through the
Reservation System on the www.pelikan.sk portal or on that of the
business partner offering Pelikan's services or if the cancellation period
has expired. If any part of the accommodation falls under the Special
Period, special conditions and related fees will apply to all those nights
reserved.
4. Unpaid Bookings for Accommodation for a period other than the
Special Period may be changed and cancelled free of charge no later than
48 hours before arrival at the hotel. The hotel or service provider may
require a longer cancellation period for the Booking. The cancellation
period will be specified in the reservation step of the booking. If the
booking is not settled on the date specified on the Payment Details and
under the terms of Section E of Article II, paragraph 2 of these General
Terms, or the maturity will not be extended after consultation with the
Customer Service, Pelikán will automatically cancel the Booking. For nonuse of services or cancellation of paid Bookings for Accommodation other

than during a Special Period Pelikán will charge the client and the client is
obliged to pay Pelikán a cancellation fee of at least one night and a
service fee for processing of the cancellation charged according to the
current General Commercial Terms and Conditions fees Part G. In the
event that the client claims that the Booking was cancelled directly at the
hotel, a charge of at least one night, and a fee that will be charged
according to the current General Commercial Terms and Conditions fees
Part G and the client will be obliged to pay Pelikán if the hotel or business
partner charges Pelikán later on.
5. If Pelikán issues a credit note for the non-use of a service charge to
the client, but the hotel or Pelikan's business partner later confirms that
the passenger stayed at the hotel, Pelikán will issue Payment Details to
the client for the additional night(s) payment that the client is required to
pay.`,
        },
        {
          title: "XI. Food",
          content: `1. From time to time, Pelikán, in cooperation with their partners,
organizes support offers that allow a client to receive a night free or at a
reduced price if they purchase a certain minimum stay. Occasionally, the
offer may indicate that a meal is not included in the offer. If, however, a
meal is not included, the hotel charges the passenger for the food,
usually on departure.

2. The type of breakfast included in the price for each hotel is indicated
with the names according to the following table:
American
Continental

Cold buffet
English

Hot buffet
Japanese

Israeli
Moroccan

Continental room service
Scandinavian

Scottish

Extended buffet

Chinese

Irish

Continental - a cold breakfast usually served at the table. It contains a
minimum of bread and jam with a hot drink. It may contain ham, cheese
or fruit.

Cold buffet - extended continental breakfast, but with self-service. It
usually contains the same items as continental breakfasts plus cold
drinks, cereal foods and salads.
Hot buffet - is the same as a cold buffet, but includes additional hot
meals, a minimum of bacon and eggs.
American - hot meals such as bacon and eggs served at tables.
The above information serves as a guide only and the food can vary
greatly from hotel to hotel.`,
        },
        {
          title: "XII. General provisions",
          content: `1. Legal relationships based on a contract concluded in connection with
the booking shall be governed by Slovak law. Any disputes arising out of
or in connection with a contract concluded on the basis of a booking,
including disputes concerning its validity, interpretation or revocation,
shall be exclusively governed by the jurisdiction of the Slovak courts with
Slovak as the language of negotiation.
2. Pelikán is not responsible for failure to comply with the booking due to
fire, earthquake, floods, snow calamity, epidemics, explosions, labour
disputes, riots, civil unrest, wars, acts of God, any transport, electrical or
communication systems failures or any similar events which Pelikán
cannot influence. In such cases, Pelikán will make every effort to provide
the client with alternative accommodation or to reimburse the funds paid.`,
        },
        {
          title: "XIII. Some special conditions valid for apartments and villas",
          content: `1. Where information is available, a quality evaluation shall be carried
out according to the general standard of accommodation. The competent
authorities do not always make evaluations for these facilities and these
ratings are not equivalent to the star rating standard used for hotels. The
rating is for guidance purposes only and should only be used as a general
guide, and Pelikán cannot guarantee and warrant it.
Evaluation:
Grade 1
Acceptable overall level of quality. Appropriate furniture, equipment, and
accessories.
Grade 2
Good overall level of quality. Good overall standard of facilities, services,
and guest services.

Grade 3
Good to very good level of quality. Good standard of maintenance and
decoration. Sufficient space and good quality furniture.
Grade 4
Excellent overall level of quality. Very good attention to details.
Grade 5
Exceptional overall level of quality. High level of decoration, accessories,
and equipment coupled with excellent standards of management
efficiency and services for guests. Excellent range of accessories and
personal approach.

2. Any damage whatsoever to the apartment or villa or property in them
shall be the responsibility of the person causing it, and the amount of the
damage will be charged and the reimbursement requested from the client
upon departure.
3. The passenger is obliged to comply with the rules and regulations
established by the accommodation provider.
4. The total number of people (including teenagers and children) using
the accommodation must not exceed the maximum number of people
listed in the information provided to Pelikán's clients. Otherwise,
incoming guests may be denied access to the property or may be
additionally charged.
5. Passengers are responsible for the payment of any charges associated
with the use of equipment such as electricity, gas, water, telephone,
laundry, security services and deposited with the accommodation
provider for the use of said equipment.
6. Passengers will probably be required to pay the deposit upon arrival at
the accommodation facility. Fees incurred during your stay will be
charged on your credit card.
7. Any plan of room occupancy in the accommodation which Pelikán is
able to provide is based on the specification provided to Pelikán by the
accommodation provider. The diagram is only a general view of the
accommodation. Actual size, design, accessories, equipment, and devices
may differ from what is depicted on the diagram.`,
        },
        {
          title: "XIV. Some provisions on cancellation conditions and supplementary",
          content: `conditions valid for villas and apartments
1. In addition to the Special Period, for bookings requiring a minimum
number of nights of stay for each booking (usually, but not exclusively,

three nights, seven nights or more than seven nights) a fee equal to not
less than 25% of the amount of the Reservation will be deposited for
cancellation of bookings that were made more than 9 days prior to the
date of arrival.
2. For the cancellation of a booking made no later than 8 days prior to
the date of arrival, the client will be charged a Fee of 100% of the
Purchase Order and the client is obliged to pay it.
3. If in the meantime, the number of booked apartments is reduced by
the client, the said act on the part of the client shall be considered as
cancellation of the booking of the relevant apartments and shall be
subject to cancellation conditions or cancellation of the booking. Pelikán
will always try to arrange the request without charge, but Pelikán cannot
guarantee to do so free of charge.
4. No fee will be charged for amending the length of stay specified in the
booking if it is made earlier than three days prior to the date of arrival.
Charges that apply to changes made within three days of arrival will be
listed on the booking.`,
        },
      ],
    },
    {
      title: "D. GENERAL TERMS AND CONDITIONS OF THE AGENCY FOR INSURANCE, VISA,",
      content: `TRANSFERS, PARKING CARDS, PREMIUM ASSISTANCE SERVICES AND OTHER
SERVICES`,
      subsections: [
        {
          title: "I. Brokering insurance",
          content: `1. Pelikán is, on the basis of the Brokerage Agreement concluded
between Pelikán and the insurance company Generali Poisťovňa, a.s.,
branch company Európska cestovná poisťovňa, based in Lamačská cesta
3 / A, 841 04 Bratislava. Registered in the Commercial Register of the
Municipal Court Bratislava III, section: Sa, Insert No: 1325 / B, Company
ID: 35 709 332, Tax No.: 2021000487, VAT No.: SK2021000487
(hereinafter referred to as "Insurance Company") authorized to broker
and conclude travel insurance contracts for clients. The insurance
contract is deemed to have been concluded on the day on which the
entire amount of the premium was credited to Pelikán’s account. The
content of the insurance is determined by the client in the reservation
process on the Pelikán web portal, or on the portal of a business partner
offering Pelikán services. The exact scope of cover and conditions are set
out in the General Insurance Conditions of the Insurance Company and
the Contractual Arrangements of the Insurance Company for Travel
Insurance, which are available on the Pelikán internet portal, or on the
portal of a business partner offering Pelikán services. After the conclusion
of the insurance contract, the client receives the Insurance Policy
Confirmation, Client Card, General Insurance Conditions of the Insurance
Company and the Contractual Agreement of the Insurance Company for
travel insurance.

2. The client acknowledges that the insurance relationship arises directly
between the client and the insurance company. In dealing with
compensation for an insured event, the insurance company is in direct
relationship with the client and Pelikán is not required to assess the
existence or the sum claimed from this relationship. The client hereby
acknowledges that any claim arising out of an insurance relationship will
be enforced directly by the insurer.`,
        },
        {
          title: "II. Arranging visas",
          content: `1. As part of its services, Pelikán arranges services related to the
arranging for and provision of tourist visas. If a client is interested in
obtaining a visa, the client shall send their request via e-mail to
viza@pelikan.sk. Pelikán then informs the client electronically of the
conditions for the provision of visas and the amount of the visa service
charge (hereinafter referred to as "visa provision"). If the client is
interested in the arranging of visas on the basis of the conditions for the
provision of visas, the client is obliged to send their consent to the visa
provision to Pelikán by email. If the client wishes to have the provided
visas delivered by courier, the client will be informed in advance of the
delivery terms. With the client's consent, Pelikán sends the Payment
documentation to the client by e-mail and the client is obliged to pay the
amount by the due date stated on the Payment documentation. Upon
payment of the fee for services related to visa provision, Pelikán will send
a receipt to the client. Visa issuance within 5 business days will incur a
30% surcharge to the visa fee the client is due to pay.
2. The client shall pay the Pelikán service fee and the fee of the relevant
embassy for the issuance of visas by: wire transfer to the relevant bank
account, deposit into the relevant account about which the client shall be
informed by Pelikán, or by credit card.
3. The provision of written consent of the client for the processing of
personal data to be sent to the client by e-mail is a prerequisite for the
provision of visas. The client shall deliver this written consent together
with the documents required for the issuance of visas.
4. The client is obliged to deliver to Pelikán all the required documents
for the issuance of a visa. The delivery of all relevant documents and
written materials related to visa provision shall be carried out either
personally by the client at Pelikán office, by post or by courier. At the
office, the client shall fill out a receipt protocol listing all the documents
that the client delivered to Pelikán. Whatsoever delivery charges are
covered by the client. The client will be informed in advance of the
courier service charge by e-mail. Upon payment of the booking and
delivery of all necessary documents, Pelikán will begin the process of
arranging for and provision of the visas.
5. In arranging for and provision of visas Pelikán acts and represents
exclusively as an intermediary. For this reason, Pelikán is not responsible
for any damages caused to the client as a result of failure to issue visas

by the relevant embassy. As regards the cancellation of a given booking
for the issuance of visas to clients, it is necessary to cancel the booking
at the latest until all the documents have been submitted to the
individual embassies. Visa fees are irrecoverable irrespective of the
success of issuance of the visa. Pelikán is not responsible for the
truthfulness of the data provided by the client, and it is not mandatory to
check and verify the correctness and veracity of the client's data. Pelikán
does not guarantee the issuance of visas by the relevant embassy, even
in the case of flight tickets having been purchased by clients through the
Pelikán booking system, the time and the time limits for issuing visas are
governed by the rules of the relevant embassy.`,
        },
        {
          title: "III. Sale of tickets for transfers",
          content: `1. Transfer – a transport service for people and, where applicable, their
personal luggage by means of bus, train, boat or car, for which Pelikán
arranges the sale of tickets.
2. The conditions of carriage, including the timetable for the transfer,
shall be determined by the particular transporter providing the transfer.
3. A transfer ticket may be purchased as a stand-alone service or may be
included as part of a tour organized by CK Pelikán or by another tour
organizer sold by CK Pelikán as a travel agency. A separate service is
also available if the transfer ticket has been purchased at a later date. If
a ticket is sold as a stand-alone service, Pelikán as the ticket sales agent
is only responsible for the correct sales and issuance of tickets. The
carrier is responsible for any problems encountered in the execution of
the relevant connection for which the passenger has purchased the
ticket, including responsibility for the delay of the connection.
4. Pelikán recommends that the client, in the event of a transfer to other
services for which the client has purchased a ticket, e.g., an air carrier,
has sufficient time and has anticipated the possibility of occurrence of
extraordinary circumstances that may cause their delayed arrival at the
airport. If due to a delayed flight, the client fails to make the transfer for
which a ticket has been purchased, Pelikán is not responsible for the
delays and damages resulting to the client. In this case, the client is
entitled to contact the carrier whose connection was delayed with their
claim.
5. Slovak Lines a.s. bus ticket is valid for a specific date only, cannot be
changed and is non/refundable if not used. Clients are obliged to reserve
a bus seat for a specific time in advance, either:
by phone on tel. number: 18 211, +421 2 55 422 734; or
by e-mail at info@slovaklines.sk

IV.

IV. Sales of car park cards
1. Pelikán also offers arranging the sale of car park cards. Car park cards
provide the buyer with the lease of a parking space for parking a
passenger car for a certain period of time. Pelikán acts as an
intermediary for parking at the airport, not the provider. Booking car
park cards can be made electronically, by telephone or personally at the
Pelikán office at pelicantravel.com s.r.o., Pribinova 17954/10, 811 09
Bratislava, Slovenská republika
2. Car park cards may be in electronic form as an online parking
reservation or in printed form in the form of a paper card with the
designated length of parking.
3. Electronic car park cards are sold by Pelikán for parking at the airport
in Bratislava and at the airport in Prague. In their booking, the client, on
their own responsibility, books a car park card with a sufficient time
reserve to enable them to make a transfer from the parking lot to the
airport and to hand over their baggage. The car park cards are in
electronic form and are sent to the client's email address after payment.
The electronic car park card contains the exact date and time of arrival,
as well as the exact date and time of departure from the car park.
Parking is paid for the stated period of time. If the client exceeds the
length of parking, the difference in the price will be paid directly to the
car park operator. Upon arrival at the parking lot (for parking at the
Bratislava airport), the clients need to show the printed parking voucher.
Otherwise the car park operator can refuse the service without obligation
to return the already paid parking fee or compensation. Transfer from
the car park to the airport and back is automatically included in the
booking of the electronic car park card and is operated by a minivan 24
hours a day.
4. Car park cards sold in print are sold by Pelikán for parking at Vienna
Airport (Parkhaus 4, Parkplatz C and Parkplatz Mazur). The car park card
can be picked up personally from the Pelikán offices if the client states it
on the booking or let us know immediately after it was sent. Otherwise,
the car park card is sent via courier to the address the client supplied
when purchasing the car park card. The client is required to provide an
address that exists and to which this car park card can be delivered in
order to be timely picked up. In the event the car park card cannot be
delivered to the client at the specified address or the client fails to collect
it at this address, the car park card is returned to the sender and Pelikán
shall charge a fee of €5 for the delivery of the car park card to the client
at a replacement address. If the client chooses to collect the car park
card from the Pelikán offices as the replacement delivery location and
notifies Pelikán of this fact in time, either by telephone or by e-mail, the
fee of €5 will not be charged. The car park cards are marked with the
number of prepaid hours and their total validity. The car park card is a
one-time stay. Multiple car park cards (for the same car park i.e.
Parkhaus 4, etc. ) can be used to cover the due parking fee. Any
remaining prepaid hours after one card use are not carried over. The car
park card is valid from the date marked on the card. Pelikán is not
responsible for damages caused by improper use of the card. In the

event of a confirmed car park card failure, the client is only entitled to a
refund of the amount paid by the travel agency for the car park card.
There is no entitlement to any further compliance in connection with the
non-functionality or non-use of the car park card. The car park operator
reserves the right to redirect the vehicles to other parking areas when
parking spaces in parking areas are reduced during construction work at
Vienna Airport. Purchasing a car park card is not a guarantee of a free
parking space in the selected parking area.
5. In the event of a problem being detected with a car park card, any
complaints on the functionality of the car park card must be submitted
immediately at the airport to a car park official at the "Kassa" office on
the ground floor of the Parkhaus 4. For the Mazur car park, the claim
must be submitted at the ticket office located on the right of the exit
ramp. Any additional complaints may be rejected by the car park
operators in the case of car park cards in printed form because of the
impossibility to check the status of the car park card on the spot. Pelikán
is not responsible for any incorrect handling of the car park card. Pelikán
as a service agent is not responsible for the non-functioning of the car
park card which was not caused by their fault. If a client cannot submit a
claim against their car park card at the place of parking for a variety of
reasons, they may also file a complaint through Pelikán in the manner
described in Part E. COMMON PROVISIONS OF THE GENERAL TERMS AND
CONDITIONS APPLICABLE TO SALES, TRAINING, ACCOMMODATION,
INSURANCE AND SALE OF OTHER PRODUCTS / SERVICES, Art. V.
Complaint procedure. In the event that the car park card fail is caused by
the issuing authority of these cards, Pelikán will file a claim on the car
park card to the authority responsible for issuing the car park card.
6. Car park cards in printed form must be used for the period of validity
stated thereon, electronic car park cards are valid for the exact dates and
times indicated thereon. In the case of electronic car park cards,
cancellation of parking is possible within 3 days prior to parking. Parking
cards in printed form can be cancelled at least 6 months prior to the
expiration of the car park card. Electronic car park cards are cancelled by
sending an e-mail request to letenky@pelikan.sk; car park cards in
printed form are cancelled by sending a cancellation request in writing to
pelicantravel.com s.r.o., Pribinova 17954/10, 811 09 Bratislava,
Slovenská republika together the car park card. Without receiving the car
park card in printed form, this type of car park card cannot be cancelled.
The cost of sending a cancellation request and a car park card is borne
by the client. The client will be reimbursed the parking fee on the bank
account from which the car park card was paid. The charge for the
cancellation of the car park card, whether in electronic or printed form, is
€25 per car park card. If the car park card was part of a client's booking
that included a flight or a tour / accommodation and these services, due
to the airline / tour operator or the accommodation provider, were:
a) cancelled and the client decides for this reason to cancel the parking
card, the cancellation fee will not be charged by Pelikán;
b) modified to extend the required parking time beyond the booked
parking card, the client may either cancel the parking without being

charged the cancellation fee by Pelikán or may extend the parking time
for the respective fee for the relevant length of extended parking time in
the respective parking lot;
c) modified so that the parking time is preserved according to the original
booking and only changes to the dates are needed; Pelikán will change
the parking period free of charge upon request;
d) modified so that the parking time is shortened, the client is not
returned the partial amount for parking and cancellation of the parking is
possible only for a fee.`,
        },
        {
          title: "V. Car rentals",
          content: `1. Car rental services are provided via the company Booking.com
Transport Limited, which provides global leasing of cars and other
vehicles. The whole ordering process and payment is carried out in the
booking system of this company and Pelikán does not have access to
client orders or to payment details, service itself, or data relating to
additional purchased products/services besides the car rental. In the
complaint proceedings relating to the rental of vehicles, Pelikán can only
assist the Client with a communication, it is not authorized to make any
decision regarding the individual complaint. Such authority has only the
company Booking.com Transport Limited and its business partners –
relevant car rental companies and insurance companies. Pelikán is
neither responsible for the booking process, including the payment for
services, nor for the provision of services or any other matters arising in
connection with the rental of the vehicle.`,
        },
        {
          title: "VI. Online check-in",
          content: `1. Pelikán offers its customers the option to order an additional check-in
service for their tickets. This service is basically available to the tickets of
low-cost airline carriers purchased in accordance with Part AIII of these
GTC, however, we recommend you order it always beforehand at our
Customer Service, as the carrier might not provide it for all flights. The
service may be ordered after the purchase of the tickets; however, it can
be provided by Pelikán only at the time allowed by a particular airline
carrier under its business terms. The service is charged according to the
tariffs set out in the Section G of these GTCs.
2. For the proper provision of services, it is essential for the Client to
provide correct information about all passengers for whom the service is
ordered. This concerns the following data:
a) Name and surname
b) Gender

c) Date of birth
d) Nationality
e) Type and number of the travel document
f) Country of issue and date of expiry of the travel document
The data must be consistent with the data provided in the travel
documents, with which the passenger shall identify himself/herself during
the flight. If the data provided by the Client proves as incomplete or
incorrect (as an incorrect may also be considered a typo in one letter or
digit), its correction by the airline carrier may be charged, and boarding
may be also be refused to the passenger, with all these and subsequent
costs borne by the passenger.
3. The ordered and paid online check-in service is unchangeable and
irrevocable by the Client. After online check-in, for some airline services
there are, as a rule, extra check-in cancellation charges, such as changes
in flights or passengers, in order to provide such service. Subsequently, it
is necessary to perform online check-in again.
4. With some airline carriers the online check-in service may include
other services (e.g. the option to choose a seat), we recommend you
always to ask about these services.
5. If the service of the airline operator is confirmed to the Client, but
changes or cancellations of the ticket to which it is linked occur, the
cancellation of the service is subject to the published terms and
conditions of the airline operator applicable to the flight. The Pelican's
administrative fee is always irrecoverable. Pelikán is not liable for any
damages incurred by the Client due to the airline carrier’s failure to
provide the service if the changes/cancellations of the ticket have
occurred, unless they were caused by Pelikán's unlawful act.
6. If technical problems occur on the airline carrier side (e.g. at its web
portal), and if, after repeated attempts, it is not possible to provide this
service to Pelikán, the Client shall be refunded the full amount for the
service ordered. However, Pelikán is not liable for damages incurred by
the Client due to unavailability of the service, unless it was caused by
Pelikán's unlawful act.`,
        },
        {
          title: "VII. Priority Boarding",
          content: `1. Pelikán offers its Clients the option to order a priority boarding service
to the ticket. This service is basically available for the tickets of low-cost
airline carriers purchased in accordance with Part A III. of these GTC,
however, we recommend the Customer to order the service as soon as
possible after the ticket has been purchased. At the latest, it is possible
to request a service before a check-in is made for a specific ticket.
However, since airline carriers offer the service only for a limited number

of passengers on that flight, the Pelican can not guarantee that the
service will be confirmed by the airline carrier. The service is charged
according to the tariffs set out in the Part G of these GTCs, and the fee is
also charged by the airline carrier, while the Client is always informed
about the total price of the service.
2. The priority boarding service confirmed by the airline carrier is
unchangeable and irrevocable by the Client.
3. The priority boarding service may include other services (e.g. another
piece of cabin baggage) provided by some airline carriers, we
recommend you to always ask about these services.
4. If the service of the airline operator is confirmed to the Client, but
changes or cancellations of the ticket to which it is linked occur, the
cancellation of the service is subject to the published terms and
conditions of the airline operator applicable to the ticket in question.
Pelikán's administrative fee is always irrecoverable. Pelikán is not liable
for any damages incurred by the Client due to the airline carrier’s failure
to provide the service if the changes/cancellations of the ticket have
occurred, unless they were caused by Pelikán's unlawful act.`,
        },
        {
          title: "VIII. Gift vouchers",
          content: `The client has the option to buy gift vouchers with a minimum value of €
25, on the www.pelikan.sk website using the Gift vouchers tab or by
sending a request to pobyty@pelikan.sk. Subsequently, the payment
documentation will be sent to the client via email. After payment of the
total amount of the gift voucher, a unique code will be created and sent
to the client.
The gift voucher can be used by the client or by the person who will
submit the voucher (or more precisely, the unique code displayed on the
voucher) to Pelikan to purchase flight tickets and/or accommodation and
/or package tour or a combination of the products of their choice, chosen
from the offer on the www.pelikan.sk website.
The gift voucher can be used online when booking selected services. The
client submits the entire unique code displayed on the voucher into the
box labelled “Discount/Gift voucher” at the appropriate service booking
step. Subsequently, the client has the option to check the counted-in
value of the gift voucher prior to confirming and sending a booking when
a part of or whole booking is paid using the gift voucher, depending on
the value and type of booked services.
If the client fails to apply the gift voucher or if the amount counted-in
does not match the value of the gift voucher, we recommend that the
client contacts our Customer Service during business hours.
Pelikán is not responsible for increasing the price of selected products
when the gift voucher cannot be used due to an incorrect use of the

voucher, using an expired voucher or any other reason which is not
caused by Pelikan´s conduct.
The client can also use the gift voucher for an offline booking. However,
in order to prevent any price increases of selected products/services,
please contact our Customer Service (during the office hours) informing
our agent about the intention of using the gift voucher as a payment
method on the date of the booking placement. Please do so at least 3
hours before the earliest due date of the client’s booking. Otherwise,
Pelikan is not responsible for an increase in the price of the selected
products.
Pelikan does not guarantee that the price of selected services/products
will not be increased by a supplier up to the moment of the issuance
/purchase of the booked products/services due to the way of selling
these products/services determined by air carriers and other suppliers of
the products/services.
The client thus uses the gift voucher knowing that there is a risk of a
legitimate price increase by the low-cost airline. If the ticket price
increases, the client can but does not have to accept the price. If the
client does not accept it, Pelikan will find another reasonable alternative.
If none of the options is suitable for the client, the client has the right to
a full refund and to reuse the gift voucher.
The gift voucher is valid from the moment of its issue until the end of the
following calendar year, unless stated otherwise. The gift voucher is not
transferable, non-refundable and it is not possible to exchange the
voucher for cash. Cancellation and changes of services/products
purchased with the gift vouchers are governed by the terms of the
suppliers of the particular services and Pelikan, regardless of the fact,
whether they were paid in full or in part by means of the gift voucher.
The client may use the gift voucher to buy services at least equal to the
value of the gift voucher.
If the service is purchased at a lower value than the nominal value of the
gift voucher, the price difference is non-refundable. If the service
purchased is of a higher value than the gift voucher, the price difference
will be invoiced to the person who submitted the voucher to Pelikan.
The gift voucher can be used for more than one purchase/order. For
several purchases/orders the client must request the Customer Service
to enable this possibility in advance. The gift voucher cannot be
redeemed after payment. Several gift vouchers can be combined and
redeemed at the same time.
Pelikan is not responsible if the gift voucher is misused by an
unauthorized person.
Gift vouchers cannot be used for car rental services and services related
to car rental and any service related to a service in the Cars tab on www.

pelikan.sk, nor to book accommodation in the Hotels tab on www.pelikan.
sk.

a. Special gift vouchers
1. Special online gift voucher
Pelikán may offer its Clients a special online gift voucher as a form
of refund.
If the Client opts for the gift voucher as a form of refund for a
cancelled flight, Pelikán will issue the voucher and send it via e-mail
as soon as the airline approves the amount of the refund. It is not
possible to change the form of refund after issuing the special gift
voucher.
In case the Client does not use the special online gift voucher by its
expiry date, the Client may request a refund in form of a financial
compensation for the unused amount of the special gift voucher
after this date.
Pelikan may offer clients a bonus on top of the amount reimbursed
by the airline. In order for the client to be able to use the bonus, the
Special Online Gift Voucher must be redeemed in full by the
voucher's due date, otherwise the client's entitlement to the bonus
will expire. The bonus is non-refundable.
Other provisions of these General Terms and Conditions, Part D,
point VIII. Gift vouchers will be used appropriately for the special
online gift vouchers.
2. Voucher for a cancelled flight
Pelikán can issue to the client a Voucher for a cancelled flight
related to a form of refund for a cancelled flight provided by an
airline. The executor of the Voucher for a cancelled flight is the
airline which issued the original flight ticket and which cancelled the
flights.
The specific conditions and options of using the Voucher are
determined by the airline, the products and services of which can be
bought using the Voucher for a cancelled flight. The Voucher for a
cancelled flight is related to the conditions and options of use
determined by the airline. The Voucher for a cancelled flight cannot
be used to pay a service fee or other fee of Pelikán, nor can it be
used for travel insurance, etc. After its validity has expired, the
Voucher for a cancelled flight is non-refundable, unless otherwise
stated in a specific case. The Voucher for a cancelled flight is nontransferable and can only be used by the passenger of cancelled
flights, unless otherwise stated in a specific case. The Voucher for a
cancelled flight can be used for one purchase (order) only, unless

otherwise stated in a specific case. All the necessary information
and instructions for using the Voucher for a cancelled flight will be
delivered to the client electronically together with a unique Voucher
code, and will also be available on Pelikán’s website in the Order
Management section for the original order in which the flights were
cancelled.
The airline to which the use of the Voucher for a cancelled flight is
bound is responsible for the options and range of using the Voucher
for a cancelled flight. As the implementer, the airline reserves the
right to modify the conditions of its use even after its issue. In case
the Voucher has already been used by the client, Pelikán will not
comply with the client's request for its use and may cancel the
Voucher for a cancelled flight without compensation.
Other provisions of these GTC in Part D, Point VIII. Gift vouchers will
be used appropriately for the Voucher for a cancelled flight.

b. Discount code
Pelikán may offer the Client a discount on the purchase of products
and services in the form of a discount code, which the Client or the
person providing the code can use, depending on the type of
discount code to purchase flight tickets and/or accommodation and
/or a tour, or a combination of products according to his/her choice
from the offer of services on the www.pelikan.sk portal.
Pelikán can offer a unique discount code to the Client as part of a
complaint procedure; it also offers general discount codes within
marketing campaigns and for affiliate partners as a discount on the
total flight ticket price, and may provide a unique discount code for
the Premium support product as a discount on service fees.
The validity, way of using a particular code type, and value of the
discount code is specified to the Client in more detail when the
discount code is provided. The discount code cannot be used to
purchase a gift voucher. The discount code is transferable, nonrefundable, and cannot be exchanged for cash.
Cancellations and changes to services/products purchased with the
discount code are governed by the terms and conditions of the
suppliers of particular services and of Pelikán, regardless of whether
such have been paid in full or in part by means of the discount code.
In the event of order cancellation, discount codes are nonrefundable and the Client is not entitled to reuse them.
Pelikán is not responsible for any misuse of the discount code by an
unauthorised person.
Other provisions of these GTC in section D, provision VIII. Gift
vouchers shall apply for discount codes.

IX. Premium customer service - premium assistance services
1. Premium Customer Service (hereinafter referred to as “Premium CS”)
includes the high standard services of Pelican Customer Service which
can be ordered exclusively during a flight ticket order. A subsequent
order of Premium CS is not possible. Premium CS applies only to the
order and flight tickets with which it was ordered. Premium CS also
includes the following services in comparison to standard Customer
service:
a) Prolonged Customer Service contact time, more precisely Monday–
Sunday, 8:00 a.m. to 9:30 p.m., including national public holidays.
During standard Customer Service opening hours, Monday–Friday, 9:00 a.
m. to 5:00 p.m., the Customer Service is at the client’s disposal in
normal mode, but during and after these hours it is possible to contact
Customer Service only by a so-called Call button which is available after
the client logs into Order Management. The client will be contacted by
Pelican via phone within 15 minutes after pressing the Call button;
b) 100% discount on the Pelican service fee during the first flight ticket
change or cancellation by the client, including the so-called void flight
ticket on the date of issue, if the airline company allows it;
c) 100% discount on the Pelican service fee for online check-in, if it is
allowed on the given flight by the airline company. The service is
provided according to the flight ticket either automatically or upon client
request, which can be done in the Order Management section and after a
successful online check-in a generated boarding pass is sent to the client
via electronic mail to the email address they have specified. The
opportunity to do the online check-in and its date depend on the
conditions of the particular airline company and it is inevitable that the
client provides Pelican with all of the necessary data;
d) 100% discount on the Pelican service fee for the provision of special
services with the flight ticket, if their provision is possible and confirmed
by the airline company (see the modification of special services in part A
of these General Terms and Conditions);
e) Discount on the next order of services through Pelican whose amount
depends on the overall price of the flight ticket order together with which
the client orders the Premium CS (the price will not reflect other services
that have been ordered such as insurance, parking etc. nor will it reflect
additionally bought services with the flight ticket, including special
services). The discount rate is the following:

The overall flight ticket price in the order: Discount rate:

€ 0-125

€5

€ 126-200

€7

€ 201-500

€ 10

€ 501 € and more

€ 15

The discount is provided in the form of a unique discount code which is
sent to the client after the flight ticket order has been issued by
electronic mail to the email address they have specified. The discount can
be used online during the next order and the code is valid for 3 months
following the date of creation and sending. The discount is only
connected to the service fee and it is not possible to use it to buy gift
vouchers. Adequate provisions of these General Terms and Conditions
governing gift vouchers will apply to the use of this discount.

2. It is not possible to cancel the Premium CS after the payment, the
ordering fee of €19/order is non-refundable. The use of services and
advantages resulting from the Premium CS is voluntary; if they are not
used or only partially used, no claims for reimbursement arise, not even
for an aliquot amount. The services and advantages that are included in
the Premium CS cannot be transferred to a different order.`,
        },
        {
          title: "X. Accommodation - booking.com",
          content: `1. Order of accommodation through the Hotels tab, or via links to an
order of accommodation as an additional service in Order management,
or by emails which are sent to the client following an existing order of
other services is made by Booking.com B.V. which globally mediates
orders of accommodation. The entire order as well as the payment are
carried out in the reservation system of this company and Pelikán does
not have access to these client orders or payment data, data concerning
the provision of the service included in the order or data about other
additionally purchased products/services related to accommodation. In
case of a complaint procedure related to such order of accommodation
and other services, Pelikán helps clients only with communication, it is
not eligible to rule on respective complaints. Only Booking.com B.V. and
its business partners – concerned accommodation facilities and
potentially the providers of other ordered services – are eligible to rule.
Pelikán is not liable for the ordering process of accommodation and other
services including the payment for ordered services, or for the proper
provision of these services or other potential circumstances that occurred
in relation to the order of accommodation. Pelikán is not eligible to
provide confirmations about orders which are carried out in such manner,
these need to be requested from Booking.com B.V. or respective
providers of accommodation and other services.

XI. Attractions and trips
1. Attraction – an entertaining or educational service with a fee which is
organised by Bonferi Technologies s.r.o. or its business partner, e.g.
water park, tourist monument, museum, theatre performance etc.
Trip – a travel or experience service with a fee which is organised by
Bonferi Technologies s.r.o. or its business partner, e.g. city walking tour,
tour bus, diving etc.
An order of attraction/trip is made by Bonferi Technologies s.r.o. which
globally mediates the sale of experiences. The entire order as well as the
payment are carried out in the reservation system of this company and
Pelikán does not have access to these client orders or payment data,
data concerning the provision of service included in the order or data
about other additionally purchased products/services related to the
ordered attraction/trip. In case of a complaint procedure related to such
order of attraction/trip and other services, Pelikán helps clients only with
communication, it is not eligible to rule on respective complaints. Only
Bonferi Technologies s.r.o. and its business partners – concerned
attraction/trip sellers – are eligible to rule. Pelikán is not liable for the
ordering process of an experience and other services including the
payment for ordered services, or for the proper provision of these
services or other potential circumstances that occurred in relation to the
order of attraction/trip. Pelikán is not eligible to provide confirmations
about orders which are carried out in such manner, these need to be
requested from Bonferi Technologies s.r.o. and its business partners –
concerned attraction/trip sellers.`,
        },
        {
          title: "XII. Tickets",
          content: `1. Ticket – is a piece of paper that has a certain value and represents a
confirmation of the purchase of admission to a specific event, the sale of
which shall be arranged by Pelikán at the client’s request.
2. A ticket is ordered through Desert Adventures that globally arranges
the sale of tickets for various events. The entire order is placed and full
payment is made through Pelikán. Tickets can be ordered electronically,
by phone or in person at the Pelikán office at pelicantravel.com s.r.o.,
Pribinova 17954/10, 811 09 Bratislava, Slovenská republika. Based on
the data provided by the client, Pelikán shall issue an invoice for payment
and order the ticket from Desert Adventures or its business partner. After
placing the order, Pelikán shall send the client the ticket, invoice and the
current conditions of the event.
3. The current conditions of admission to the event or the general terms
and conditions of the event organiser are available to the client during
the ordering process and can also be found directly on the website of the
selected event or event organiser.

4. Pelikán acts as an entity arranging the service, i.e. it is neither the
service provider nor the event organiser. In this process Pelikán only acts
as a place of payment and therefore shall not be liable for any kind of
damage incurred by the client as a result of the event not taking place.
5. In case of a complaint procedure concerning a ticket order and other
services, Pelikán helps clients only with communication and is not
authorised to resolve individual complaints. Only Desert Adventures and
its business partners – the event organiser – are authorised to do so.`,
        },
      ],
    },
    {
      title: "E. COMMON PROVISIONS OF THE GENERAL TERMS AND CONDITIONS",
      content: `APPLICABLE TO THE SALES OF AIRLINE TICKETS, TOURS,
ACCOMMODATIONS, INSURANCE ARRANGEMENTS AND SALES OF OTHER
PRODUCTS/SERVICES`,
      subsections: [
        {
          title: "I. Delivery",
          content: `1. Tickets and other products/services shall be issued and send to the
client after they are paid for, which means the total amount for the
product, including any additional services ordered and discounts is
credited to the bank account of Pelikán, unless their issuance is
dependent on other circumstance, which conditions their issuance and
delivery.
2. Tickets and other products/services will be delivered to clients
depending on the form determined by the supplier, which cannot be
influenced, in the following way:
(i) by an E-mail - the system automatically checks the possibility of
issuing an electronic ticket. If the ticket can be issued electronically, the
electronic ticket will be sent only electronically by email to the email
address provided during the process of ordering tickets and/or other
products/services. As a rule, other products/services and related
documentation will be sent to the client via email, unless Pelikán decides
to deliver other products/services and related documentation via a
courier.
(ii) by a courier service within the SR - with this option, the client will
be automatically charged with a fee, the amount of which is determined
according to the current fee rate of the GTC, part G for the delivery of
tickets and other products/services by courier service within the SR. In
this case, the ticket and/or other products/services are delivered directly
to the client at their address on the next business day after crediting the
payment, if it has been made according to the Article II, Section E, par. 2
of these GTC, in case of delivery outside of Bratislava. In case of delivery
within Bratislava, the ticket will be delivered on the day of payment
crediting, if performed according to the Article II, Section E, par. 2 of

these GTC. The company Pelikán is not liable for damages incurred by
the client due to late delivery of the shipment. An external courier
company is responsible for the delivery. The delivery options, for the
applicable surcharge, on Saturday and delivery before 8:30 or 10:30 on
the next day, should be verified at the Customer Service.
(iii) by a courier service outside the SR – with this option, the client
will automatically be charged according to the current contract with the
courier company, of which the client will be informed in advance and will
be able to decide whether to use this option. Selected countries and
shipping rates within their territory are listed in the current GTC Tariffs
for the delivery of tickets by couriers to the countries listed there. An
external courier company is responsible for the delivery.
3. It is the client's responsibility to confirm their flight with Pelikán
Customer Service at least 24 hours before the departure, or directly with
the airline operator, should the operator change its departure time or
cancel the flight. The company Pelikán is not liable for possible
cancellation of flights made by the airline operator or for changed
departure times. Should a change or cancellation of the flights occur, or
should the company Pelikán be notified outside of its opening hours, or
less than 24 hours prior the departure, the client is obliged to claim any
damage incurred directly at the carrier from whom they bought the
tickets.
4. The company Pelikán recommends its clients to get to the airport in
time, i.e. at least 2 hours before the scheduled departure, unless
otherwise indicated by the carrier. For flights from/to Israel, transatlantic
flights and so-called long-haul flights, which are usually defined by each
airline operator itself, the clients need to arrive at the airport at least 3
hours before the scheduled departure.`,
        },
        {
          title: "II. Payment terms for services provided",
          content: `1. The client can make payments to the company Pelikán for the tickets
and other products/services in the following ways:
(i) by bank TRANSFER/direct DEPOSIT to the account - based on
payment instructions automatically generated by the system. Payment
instructions are provided in the email sent by Pelikán confirming the
order of tickets, tour, insurance, and/or any other product or service. The
client may pay the total amount to any Pelikán account indicated in the
Payment documentation. The client must provide a correct variable
symbol for the payment. It is up to the client to choose the appropriate
payment method in order to credit a full amount to one of Pelikán's
accounts on time, i.e. until the due date specified in the payment
instructions. If, due to the client's incorrect indication or failure to
provide indication, it is not possible to identify the payment correctly, the
time when the payment was correctly identified is considered as the
crediting time.

(ii) by PAYMENT BUTTONS such as SPOROPAY, VÚB ePLATBY or
TATRAPAY - This form of payment with use of the appropriate payment
button is intended exclusively for clients of indicated banks who have
active internet banking service. Following the payment made via the
bank's internet banking service, the clients are redirected back to Pelikán
web site automatically or via the client actively clicking on the link/button
displayed directly by the relevant banking institution. If the client closes
the page and they are not returned back to the Pelikán website, there
may be an error in the communication between Pelikán and the banking
institution, which may lead to a failure in the identification of the
payment within the Pelikán system. Therefore, we recommend clients to
wait until Pelikán webpage is displayed. If, after successful payment, The
Pelikán website does not appear to the client, we advise them to contact
us immediately. The payment is considered as executed following the
electronic feedback from the bank about the crediting transaction on
behalf of Pelikán. If our online system does not receive such feedback for
any reason beyond our control, we are unable to verify the successful
execution of the transaction, therefore the payment is deemed as
executed only after the payment in question is credited to Pelikán's
account.
(iii) by PAYMENT CARD - only for holders of embossed credit cards and
payment cards with set payment authorization for online internet sales.
Other payment cards will not be accepted. If the client opted for this
method of payment and the order of the selected services is not possible
to pay by payment card, this fact will be communicated to the client via
phone or e-mail by the Customer Service Agent. The client acknowledges
that some tickets and/or other products/services can be paid for only by
a payment card. If the tickets and/or the other products/services can be
paid for only by payment card and this method of payment is not
available at that moment in the Pelikán system, the company Pelikán is
not liable for any damages incurred by the client due to unavailability of
ordering of tickets and/or other products/services. The client undertakes
to use only the payment card they are authorized to use for payments.
Pelikán is not liable for complaints if the payment card has been misused
and any related incurred damages will be recovered from the client. The
client acknowledges that payment by payment card can be made in one
or two transactions. If the payment takes place in 2 transactions, one
transaction, such as the ticket price, airport charges, or the price or part
of the price of other products may be drawn form the payment card
directly by the airline operator or other supplier of other products
/services. The other transaction usually consists of the Pelikán service
fee, the price of the ordered insurance, the courier service delivery price
of the tickets and/or other product/services or part of the price of other
products or services. If any transaction fails to perform, this fact will be
communicated to the client by phone or e-mail. In such case, the amount
in question is due to be paid by the client to one of Pelikán's bank
accounts within due date set out by Pelikán, in accordance with the
following paragraph of these General Terms and Conditions. Otherwise,
the order of products/services will be canceled without the possibility of
client's claims for damages.

(iv) Other payment methods – such as Apple Pay and Google Pay. The
payment is considered completed once we receive an electronic
confirmation from the payment gateway regarding the transaction. If, for
any reason beyond our control, our online system does not receive this
confirmation, we are unable to verify the success of the transaction, and
the payment is only considered completed when it is credited to Pelikán's
account. Pelikán is not liable for any damages arising in connection with
the processing of the payment transaction by the bank or the payment
gateway.
(v) Pelikán’s gift voucher, specified in more detail in Part D VIII of
these GTC.
2. By confirmation of the order and immediate payment via the PAYMENT
CARD or the Payment button (VÚB ePayments, Tatrapay, Sporopay, etc.)
payment methods, by clicking on the "BUY" button for the tickets of low
cost airline operators or by clicking on the "ORDER" button when
ordering other products/services, the client confirms that they irrevocably
propose to buy the selected product/service via a payment card and
agrees with Pelikán's GTC and with the contractor's terms and conditions.
When opting for a payment method of bank transfer/direct deposit, the
client irrevocably proposes to buy the selected products/services at the
moment of executing of the bank transfer/direct deposit to the credit of
to the relevant banking institution in which the transfer/direct deposit
they make.
3. The contract between Pelikán and the client is concluded at the
moment when the ordered products/services are issued by the respective
suppliers for Pelikán or purchased by Pelikán, unless stated otherwise.
The company Pelikán may issue/purchase the ordered products/services
only after all conditions have been met by the client, including the
payment and crediting of the total amount to Pelikán's account, unless
stated otherwise.
4. Travel allowance voucher (Up Rekreácia, Edenred) - only for holders of
the Travel Allowance Vouchers. This payment method can only be used
to pay for services qualifying for the application of the so-called Eligible
Expenses rule pursuant to Section 152 (a) of Act 311/2011 Coll.,
Commercial Code, as amended. Other services cannot be pait for in this
way, even if some parts of them qualify for the application of Eligible
Expenses according to the previous sentence. It is possible to use each
Travel Allowance Voucher (Up Rekreácia, Edenred) for a maximum
amount of €500/calendar year. If the price of the package is higher than
€500, the remaining amount can be paid by any other payment method
offered by pelicantravel.com. If, at any given time, the service cannot be
paid for by this payment method due to technical reasons outside of the
client´s control, Pelicantravel will make every efford to remedy this
situation. Pelicantravel will not be held liable for damages suffered by the
client due to the inability to pay for products/services by this method.
The client may only use an authorised Travel Allowance Voucher (Up
Rekreácia, Edenred). Pelicantravel will not be held liable for any damages
if the card is misused. If the client decides to cancel a service/product

that has been paid for by this payment method, the client is aware that
the cancellation fee of Pelicantravel according to the Tariff of Fees stated
in Part G of these General Terms and Conditions must be paid by a
payment method other than the Travel Allowance Voucher (Up Rekreácia,
Edenred). For this purpose, a pro forma invoice wil lbe sent to the client,
which must be paid before the refund gets processed as requested.
5. The client is required to pay the order properly and in due time,
according to the maturity date indicated in the payment documentation.
It is up to the client to choose the method of payment so that the full
amount of the order is credited to one of Pelikán's accounts within the
due date. The order is deemed to have been paid when the total amount
indicated in the payment instructions is credited to any of Pelikán's
accounts indicated in the payment instructions, unless provided
otherwise. The client acknowledges that the prices of certain
products and services may be guaranteed only after their
booking, issuance, or purchase of the product/service with a
particular supplier. The purchase and issuance of products
/services can be made only after the client has paid for them. If
the client fails to meet the due date, Pelikán reserves the right to cancel
the order and booking immediately, without the possibility to claim any
damages incurred by such cancellation or claims for changes in the prices
of tickets, tours, accommodation or other products services provided, by
the client.
6. If the above-mentioned payment conditions are not met, or the
payment is late or partial, the client will be charged a service fee upon
receipt of the payment, levied according to the current fee rate defined in
the GTC part G. The administrative fee according to the current GTC
rates will be charged to the client also when the overpayment of total
amount is refunded.
7. The client agrees with electronic form of payment instructions received
by e-mail and also agrees with the above-mentioned method of their
preparation. In the case of payment for the ordered products/services,
any payment credited by the client to Pelikán's account, is primarily used
for the payment of the payable attributions and then for the payment of
ordered products.
8. The company Pelikán reserves the right to suspend and/or stop the
execution of a payment received from the client and therefore to refuse
to provide the client with services if the company Pelikán, with
reasonable efforts, considers that the payment has been made by an
unauthorized person and/or if it, with reasonable efforts, found that there
is a reasonable suspicion that the payment is related to the legalization
of proceeds from criminal activities. Pelikán will not be liable for the
damage caused by the refusal on such grounds.
9. Pelikán will arrange possible refunds in the same way in which the
order, which is refunded to the client, was paid for.

If the order was paid for in the form of money, eligible funds will be
returned to the client in the form of money by wire transfer or to a
payment card, depending on the method of payment used by the client.
If the order was paid for in the form of a gift voucher, eligible funds will
be returned to the client in the form of a new gift voucher issued with
validity until the end of the next calendar year. Other terms and
conditions of using the gift voucher usually remain the same as in the
case of the gift voucher used by the client to pay for the order.
If the order was partially paid for in the form of money and partially in
the form of gift voucher, eligible funds will be returned as a combination
of money and a new gift voucher issued with validity until the end of the
next calendar year. If the refund amount does not exceed the value of
the gift voucher, only a new gift voucher with a residual value will be
created.`,
        },
        {
          title: "III. Personal data",
          content: `1. The company Pelikán hereby informs the client that within the
meaning of Article 13 par. (2) b) of the Act No. 18/2018 Coll. on the
Protection of Personal Data and amendments to certain acts as amended,
the company Pelikán, as the controller, will, during the term of the
contract, process the personal data of the client (as the data subject)
without their consent, since processing of personal data of the client will
be performed within pre-contractual relations between Pelikán and the
client and processing of client's personal data is necessary for the
performance of the contract, which the client proposes to conclude, and
where they act as one of the parties.
2. The client acknowledges that personal data provided by the client
within the ordering process for the purpose provided in the paragraph 1
of this Article will be further disclosed to the respective contractor as the
recipient by the company Pelikán, depending on the requirements of the
particular recipient, either all or part of them, for the provision of
services required by the client. Depending on the services ordered by the
client, the recipients of personal data will be the following categories of
recipients, who may also reside in third countries:
air carriers providing passenger transport
accommodation facilities
travel agencies, tour operators
insurance companies
car rental agencies and car rental companies
embassies, consulates

carriers providing rail, sea, bus or passenger transport
financial administration authorities
courier companies
3. If the client is a natural person, when ordering services they provide,
as a rule, name, sex, telephone number, email address, home address,
date of birth or vehicle registration number, when ordering parking. If
the client is a legal person or a trader, in addition to the personal data of
the natural persons to whom the services will be ordered, they shall also
provide billing data, i.e. business name, address with ZIP code, Company
ID, VAT ID - these are not considered personal data. In some cases, an
airline or a consulate or embassy issuing visas for entry into the country
requires the mandatory provision of additional data (so-called APIS data,
see definition and detailed description in the Part A of the GTC). If
processing of a special category of personal data regarding the client's
state of health is required, the company Pelikán, pursuant to Article 16
(2) f) of the Act No. 18/2018 Coll. on the Protection of Personal Data, as
amended, is authorized to process these data and provide them to the
entities against whom the claims are made (usually the airline operator,
insurance company). This happens only based on the express request of
the client and after receiving the relevant medical records from the
client. Pelikán is not liable for consequences if the client fails to provide
the necessary data or documents containing the data or does not provide
them in time, without any claim for damages that would have arisen to
the client as a result of that fact.
4. The person making the order of the selected services and providing
the personal data of all the clients listed in the order, by clicking on the
relevant box before sending of the order, confirms that they are, in
accordance with Article 13 par. (12) b) of the Act No. 18/2018 Coll.,
aware of the fact that Pelikán will process and store the personal data of
the Data Subject, in particular the data mentioned above and/or which
are necessary for Pelikán's activities in pre-contractual relations,
performance of the contract or negotiations for amendment of the
contract, withdrawal from the contract, etc. Such person also declares
that they are authorized to provide the personal data of all the Data
Subjects based on the authorization provided by them or authorization
provided by the law (e.g. for the legal representative). Without ticking off
such confirmation by the client, the conclusion of the contract is not
possible for contracts where the proposal for the conclusion of the
contract is made by such person through the creation of the order.
5. The client agrees, when making a call to the company Pelikán, with
Pelikán's recording of the call and the processing of personal data in
order to protect legitimate interests of Pelikán and to improve the quality
of the services provided. If personal data necessary for the performance
of the contract that the client wishes to conclude or has already
concluded are recorded, the client is informed about that fact.
6. The personal data of the Data subjects will be processed for the period
necessary to protect the legitimate interests of the controller, taking into

account also the possibility of filing complaints, reviewing the
proceedings initiated by the supervisory bodies or bringing the action in
civil proceedings. Pelikán declares that it will process personal data in
accordance with good practice and will act in a way that does not
contradict neither the Act No. 18/2018 Coll. on Personal Data Protection,
Regulation of the European Parliament and of the Council of 27 April
2016 (EU) 2016/679 on the protection of natural persons at the
processing of personal data and on the free movement of such data
(hereinafter referred to as the "GDPR Regulation"), nor any other
generally binding legal regulation, nor circumvents them.
7. The responsible person in accordance with the Article 44 et seq. of the
Act No. 18/2018 Coll. is Mr. Michal Marko. The responsible person can be
contacted by email at the address dpo@Pelikán.sk.
8. The client is entitled to require the controller to correct the incurred
personal data without undue delay. With regards to the purpose of
personal data processing, the client is entitled to supplement the
incomplete personal data. The client is responsible that all data provided
are complete and true. The client declares that they are aware of the
consequences of providing false information; in particular the fact that
such a procedure could also be classified as a criminal offense or could be
grounds for cancellation of the order or booking, refusal of service
provision by the contractor, or a reason for not granting the visa. If false
or incomplete data are provided, Pelikán reserves the right to cancel the
order of service immediately, or to adjust the price or to the full
compensation for any damage incurred due to provision of incorrect data.
In such case, Pelikán will not be liable for any damage incurred to the
client.
9. The client is entitled to ask the controller to remove the personal data
relating to them without undue delay, subject to the conditions set out in
Article 23 of the Act No. 18/2018 Coll. Furthermore, the client is entitled
to limit the processing of personal data under the conditions set forth in
Article 24 of the Act No. 18/2018 Coll. The client also has entitled to
obtain personal data relating to them which they have provided in a
structured, commonly used and machine readable format from the
company Pelikán, and is entitled for a transfer of such personal data to
another operator, if it is technically possible and if the processing is done
by automated means.
10. The client has the right to object to the processing of their personal
data due to a specific situation in cases specified by the law, including
profiling based on these provisions. The controller may not further
process personal data unless it proves the necessary legitimate interests
in the processing of personal data that outweigh the rights or interests of
the client or the grounds for exercising of legal claims.
11. If, prior to submitting an order, the client grants a special consent for
sending of special offers to their email address and consent for
processing of selected personal data for direct marketing purposes,
further the consent to profiling, the client hereby authorizes the
processing and storage of said personal data in accordance with the

Article 6 (1) of the GDPR regulation. This consent relates to the direct
marketing of information for specific services selected by the client, for
which the client grants the consent (e.g. information about new products,
services, discounts, current sales ...), allow the company Pelikán to
process them in all relevant information systems. This consent can only
be granted by a client older than 16 years. The client grants the consent
for a specific time selected by them, may withdraw the consent at any
time in full or only for the selected area. The company Pelikán, after
fulfilling the purpose of the processing, will remove the client's personal
data without undue delay and will inform the client about this fact. The
client has the right to object to the processing of personal data relating
to them for the purpose of direct marketing, including profiling to the
extent to which they are concerned with direct marketing. If the Data
subject objects the processing of personal data for the purpose of direct
marketing, the controller may not further process personal data for the
purpose of direct marketing.
12. The client is aware of the fact that the company Pelikán may assign
the processing of personal data to the processor.
13. The client hereby grants the company Pelikán the right to copy and
scan the official documents necessary for the verification and
confirmation of the data provided to the company Pelikán during the
ordering process.`,
        },
        {
          title: "IV. Client's acknowledgements",
          content: `1. For any service containing also agency services or provision of air,
bus, train or other mode of transportation, the client hereby
acknowledges that they have been informed of the General Terms and
Conditions and all the TARIFF CONDITIONS of the carrier and accepts
these conditions.
2. The client acknowledges that the company Pelikán has no
responsibility for circumstances related to the booked flight or other
routes (delay, cancellation, lost baggage, etc.). Any discrepancies and
complaints regarding the booked flight or route should be settled by the
carrier concerned.
3. The client agrees with the recording of incoming and outgoing calls of
the company Pelikán for internal purposes and the improvement of the
quality of the services provided.`,
        },
        {
          title: "V. Complaint procedures",
          content: `1. A complaint is the exercise of rights from liability for service or product
defects.
The conditions of the complaint procedure are governed by the relevant
provisions of the General Terms and Conditions of the company

pelicantravel.com s.r.o., by the provisions Act no. 108/2024 Coll. on
consumer protection and also by the provisions of § 618 et seq. Act No.
40/1964 Coll. The Civil Code as amended (if you are a consumer) or the
provisions of § 422 to § 442 of Act No. 513/1991 Coll. Commercial Code
as amended (if you are not a consumer).
The company Pelikán accepts complaints submitted:
A) via e-mail service at the address reklamacie@pelikan.sk
B) in written form at the address of the registered office of the company
Pelikán
C) personally at the registered office of the company Pelikán
D) by phone
The complaint must include a description of the specific case the client
claims.
The client is obliged to attach all documents available to them, proof of
the alleged facts or other documents supporting the claims to the
complaint. If the client incurred a damage when using services of
Pelikán's contractor, we recommend the client to request a written record
from such contractor (hotel, airline operator, car rentals etc.), which
should be submitted together with the claim to the company Pelikán. If
the client does not have such a written record, the company Pelikán must
request a response from the contractor, which may cause unnecessary
delays in handling the complaint and make it more difficult to assert the
potential claim of the client.
2. The company Pelikán is responsible only for performance of its
obligations regarding the booking of the requested product/service for
the clients.
3. The company Pelikán shall inform the client electronically about
outcome of the proceedings and settlement of the claim as soon as it is
provided, but no later than 30 days after the day the client submitted the
claim. In case of a complaint submitted electronically, the response to
the complaint will be sent to the email address from which the complaint
has been submitted. If the claim was made in writing or in person, the
reply will be sent to the e-mail address given by the client when ordering
the product/service unless otherwise agreed with the client.
4. The client, if they are not satisfied with the way Pelikán has dealt with
their complaint or if they believe that Pelikán has violated their rights, is
entitled to contact the company Pelikán with a request for redress (via an
e-mail to the address reklamacie@pelikan.sk). If the company Pelikán
rejects or fails to respond to this request within 30 days of its
submission, the Client has the right to file a petition for alternative
dispute resolution to the Alternative Dispute Resolution Body (ADR)
under Act 391/2015 Coll. on alternative dispute resolution for consumer
disputes and amendents of certain laws (ADR Act). Alternative dispute
resolution is a procedure of an alternative dispute resolution body under
the ADR Act, the aim of which is to reach an amicable settlement of the
dispute between the parties to the dispute. The ADR entities are the
bodies and authorized legal entities according to Article 3 of the Act No.

391/2015 Coll., updated list of which is available at this link. The petition
must contain mandatory particulars and the client should submit it in the
specified way, all according to the Article 12 of the Act No. 391/2015 Coll.
5. An alternative dispute resolution can only be used by a client - a
natural person who does not act in the course of their business,
employment or occupation when concluding and fulfilling a consumer
contract. Alternative dispute resolution only concerns the dispute
between the client and the company Pelikán arising from a consumer
contract or in relation to it. The ADR may require a client to pay a fee for
starting an alternative dispute resolution procedure up to a maximum of
EUR 5 incl. VAT.
6. After using the ordered services, Pelikán may contact the client with a
request for evaluation of these services for the purpose of obtaining an
overview of their satisfaction with their quality and mode of supply. If the
client decides to send the evaluation, it is not considered to be the filing
of a complaint.`,
        },
        {
          title: "VI. Final provisions",
          content: `1. The delivery of documents between the client and the company
Pelikán is performed electronically to the mutually provided e-mail
addresses or via postal services. If postal services are used, the
documents addressed to the company Pelikán are forwarded to the
address indicated in the header of these General Terms and Conditions
and, in case of shipments via courier to the client, the documents are
delivered to the client's domicile address or client's address provided to
the company Pelikán for the delivery of documents. For the delivery of
electronic documents addressed to the client, the document is considered
as delivered if Pelikán does not receive an error message about the
impossibility to deliver the document to the client's email address. For
the delivery of electronic documents addressed to the company Pelikán,
the document is considered as undelivered until the acceptance of the
document is confirmed to the client by Pelikán via a return e-mail
message. For the delivery of documents by postal service applies that, if
the shipped document is returned to the Sending Party for any reason
other than the fault on the part of the Sending Party, the letter is
considered as delivered on the expiry of a three-day period after the
return of the undeliverable shipment to the Sending Party.
2. Visa requirements and travel documents - passengers are required to
check travel documents and visa requirements not only for the
destination but also for the transit countries. Information on all
requirements and documents necessary for entry or transit in a given
country may be obtained by the client at the contacts of the Ministry of
Foreign Affairs of the country of which they are a citizen (e.g. for the
citizens of the Slovak Republic it is www.mzv.sk). Pelikán is not liable for
any damages incurred to the client if the client purchases a ticket before
obtaining valid visas for the destination or transit countries and such
visas will be rejected or not issued after the ticket is purchased. Pelikán

will also not be liable for any damage incurred to the client due to lack of
knowledge of the visa requirements, travel documents and their validity,
or failure to comply with these requirements. The airline operators are
entitled to refuse the boarding and cancel the whole remaining part of
the route to a client who does not fulfill all visa requirements to the
destination or transit country, or will not show valid travel documents at
check-in, without the entitlement for any claim to compensation for any
damage that the client may incur due to this action.
3. By providing the data and completing the order for products/services,
the client confirms that they are acquainted with the above mentioned
GTC, understand and fully agrees with them.
4. Name and address of the Supervisory body: Inspectorate of the Slovak
Trade Inspection for the Bratislava Region: Bajkalská 21/A, P. O. BOX
Nb. 5, 820 07 Bratislava
5. The client has the opportunity to view other travelers' reviews of
accommodation facilities and hotels. You can view Customer Reviews of
Pelikán clients or AI Ratings.
Reviews from our clients
We verify reviews from our clients. Published evaluations come
exclusively from Pelikán clients and are verified by the reservation
number or the customer's email.
After returning from a trip, stay, or vacation, the client may be asked for
feedback on the progress of the services via a form sent to the
customer's email address. Alternatively, he can send his evaluation
directly via the chat on the Pelikán internet portal - add a review.
Ratings are displayed from the most recently added to the oldest. The
overall rating of hotels and accommodation facilities is the arithmetic
average of the rating of the overall rating item for all customers who
rated the facility.
Ratings are on a scale of 1-5 stars, with 5 stars being the best.
We correct grammatical errors in reviews, leaving the content
unchanged. We will only publish comments that contain relevant
information about the accommodation and that will help other clients
make informed decisions and better understand the product. We reserve
the right not to publish reviews that contain:
Personal and other sensitive data
Curses, insulting and derogatory terms, or innuendos
Inappropriate or fraudulent content
Information unrelated to the accommodation or hotel
The client acknowledges that the reviews on the
pelikan.sk
portal are primarily intended for evaluating hotels and accommodation,
not for evaluating the services of an airline or travel agency. Ratings may
be shortened for web publishing purposes. Pelikán undertakes to remove
any review at the request of the client, as long as he sends a request for
its removal to the address pobyty@pelikan.sk. You can also use this
email address if you have any questions about published reviews.
AI reviews
For some hotels and accommodations, we do not have enough reviews,
so we decided to summarize for our clients, using artificial intelligence,

the most relevant available reviews from reviews on leading travel
portals, which we have translated for you. However, we do not
additionally verify the reliability of these reviews.
These reviews are visibly marked to inform the client that this is an AI
compiled summary of the reviews.
6. Based on the provisions of Sec. 14 (6) of Act No. 108/2024 Coll. on
Consumer Protection, as amended, a consumer is legally entitled to
withdraw from the conclusion of a distance contract or from a contract
concluded outside the trader's business premises, namely from a
transport contract, a tour contract, as well as short-term accommodation
contracts, contracts on the provision of long-term holiday services, the
exchange thereof and the facilitation of their re-sale, in the period
defined in Sec. 20 (1) to (3) and without giving a reason, so that any
payment corresponding to the extent of the withdrawal from such
contract is refunded to the consumer.`,
        },
      ],
    },
    {
      title: "F. GENERAL CONDITIONS OF CARRIAGE FOR AIR CARRIERS, IATA MEMBERS",
      subsections: [
        {
          title: "I. General Conditions of Carriage for Air Carriers, IATA Members",
          content: `Note
For the carriage of passengers on routes whose destination airport or
stops lie in a country other than the country of departure, the Warsaw
Convention applies, which in most cases limits the carrier's liability for
death or injury, as well as for loss of baggage and damage to the
baggage. See also a note headed "Advice to International Passengers on
Limitation of Liability" and "Notice of Baggage Liability Limitations."

Conditions of the transport contract
1. Under the term "flight ticket" used in this agreement, we mean a flight
ticket and a baggage ticket, which includes these conditions and
remarks; "carrier" means any air carrier that transports or undertakes to
transport a passenger or their luggage under this flight ticket or perform
any services related to such air transport. "Warsaw Convention" means
the Convention for the Unification of Certain Rules for International
Carriage by Air, signed in Warsaw on 12 October 1929, or the same
Convention as amended by the Hague Protocol of 28 September 1955,
whichever is applicable.
2. Carriage performed under this ticket shall be governed by the rules
and limitations of liability laid down in the Warsaw Convention, with the
exception of traffic which is not considered to be "international traffic"
within the meaning of this Convention.

3. Unless otherwise agreed, the transportation and other services
provided by each carrier are governed by (i) the provisions set forth in
this flight ticket, (ii) the applicable tariffs, (iii) the transport conditions
and the relevant carrier's rules which are their part thereof (and are
available on request at the carrier's offices), except for transportation
between a place in the United States or Canada and any other place
outside their territory subject to the tariffs in force in those countries.
4. The name of the carrier may be shown in abbreviated form on the
flight ticket; the full name and its abbreviation is shown in the carrier's
fares, regulations or schedules; the carrier's address is the departure
airport marked next to the first abbreviation of the carrier's name on the
flight ticket; contractual stops are the places marked on this flight ticket
or places specified in the carrier's flight schedules as regular stops on the
passenger's route; the transport to be carried out on the basis of this
flight ticket by successive carriers is regarded as a single operation.
5. When issuing a flight ticket to a carrier on the routes of another air
carrier, the air carrier shall issue the flight ticket only as its agent.
6. Any exclusion or limitation of the carrier's liability shall apply to the
agent, employee and agent of the carrier as well as to every person
whose aircraft the carrier has used for the transport, as well as to its
agent, employee and representative, and shall be in their favour.
7. The registered baggage shall be issued to the holder of the baggage
ticket. In the event of damage to baggage in international traffic, this
must be reported in writing to the carrier immediately after the damage
has been discovered, not later than seven days after the date of receipt
of the baggage; in case of delay the complaint must be filed within 21
days from the date the baggage was delivered. For national shipping, see
tariffs or shipping terms.
8. This flight ticket is valid for a period of one year from the date of issue
unless otherwise specified in this flight ticket, in the carrier's fares,
transport conditions or the applicable carrier's regulations. The fare for
travel according to this flight ticket is subject to change prior to the
commencement of transport. The carrier has the right to refuse
transportation if the relevant fare has not been paid.
9. The carrier shall endeavour, as far as possible, to carry passengers
and baggage as quickly as possible; times stated in the flight schedules
or elsewhere are not guaranteed and do not form part of this contract.
The carrier may, without prior notice, be able to be represented by other
carriers or use another aircraft and may, if necessary, change or omit the
landing sites indicated on the flight ticket. Flight schedules may be
changed without prior notice. The carrier is not responsible for facilitating
connections.
10. Passengers must comply with the official travel regulations, must
present the exit, entry and other required documents and must arrive at
the airport prior to the time specified by the carrier or, in the absence of
such time, in sufficient time to allow for departure formalities.

11. No agent, employee or agent of the carrier shall be entitled to
amend, modify or terminate any provision of this contract.

IT IS NECESSARY TO USE THE FLIGHTS IN THE DEFINED ORDER
IN WHICH THEY ARE ISSUED. IN THE EVENT OF OMITTING ANY
OF THE FLIGHTS SHOWN ON THE FLIGHT TICKET, THE CARRIER
HAS THE RIGHT TO IMMEDIATELY CANCEL THE REMAINING
FLIGHT SEGMENTS, WITHOUT ANY REFUND FOR ANY DAMAGE
WHICH MAY BE CAUSED TO THE CLIENT.
THE CARRIER RESERVES THE RIGHT TO CHANGE / CANCEL THE
FLIGHT AND TO REFUSE THE CARRIAGE OF THOSE PASSENGERS
WHO UPON OBTAINING A FLIGHT TICKET WERE IN BREACH OF
THE APPLICABLE LAWS, OR RATES, RULES, OR REGULATIONS OF
THE CARRIER.
THIS LIMITATION IS NOT APPLICABLE TO THE MAJORITY OF
LOW-COST CARRIERS WHO PERMIT OMITTING THE FIRST FLIGHT
AND USE OF SUBSEQUENT FLIGHTS. IN THIS CASE, WE ALWAYS
RECOMMEND THAT YOU CONTACT OUR CUSTOMER SERVICE
CENTER WITH DETAILS OF THE RELEVANT RESERVATION AND
THE POSSIBILITY OF NOT USING THE FIRST FLIGHT. OUR
AGENTS WILL PROVIDE YOU WITH PRECISE INFORMATION.

In the case of a double/duplicate reservation, the airline reserves the
right to cancel it without any claim for the damages that would arise.
Duplicate / double reservation is considered a reservation processed by
our company or other travel agency. In this case, Pelikán is not
responsible for the possible complications for the client and is also not
responsible for any possible damage to the client.
Notice to international passengers on limited liability
A passenger on a flight, the final destination or stop of which is in a
country other than the country of origin, is notified that the provisions of
the Treaty known as the Warsaw Convention may be applicable
throughout the journey, including any part thereof, wholly in the country
of origin or destination. For such passengers on route to, from or at the
agreed stop in the United States of America, the Agreement and the
special shipping contracts projected into the applicable tariffs provide
that the liability of certain carriers, participants in such special contracts,
for the death of the passengers or their injuries in most cases of proven
damage is limited so that it does not exceed USD75,000 per passenger
and that this liability up to this limit amount will not depend on
negligence on the part of the carrier. For such passengers travelling by
means of a carrier who is not a participant in such special contracts or
who are not on the way to, from, or have no stop at an agreed stopping

point in the United States of America, the liability of the carrier for death
or injury to passengers in most cases is limited to approximately USD10,
000 or USD20,000.
Note: Limit of liability exceeding USD75,000 includes statutory fees and
expenses, except for the claim in a country where there is a provision for
special statutory fees and expenses; in this case, the threshold value will
be USD58,000 without statutory fees and expenses.

Notification of government taxes and fees
The price of this flight ticket may include taxes and fees levied by
government agencies on air travel. These taxes and fees, which may
constitute a significant part of the fare for air travel, are either included
in the fare or are listed separately in "TAX / FEE / CHARGE". At the same
time, the passenger may be required to pay the extra tax and fees that
have not yet been collected.
The following note does not apply to flight tickets sold in the United
States of America for carriage originating in the United States.

Boarding refused due to overbooked flight
In countries where Compensation rules for denied boarding are in force,
carriers use compensation plans for confirmed booking passengers who
have been denied boarding due to inaccessibility of the seats due to
overbooking of the flight. More detailed information on these plans is
available at the airline offices.

Time for check-in
The times shown on this flight ticket or in the flight plan (if listed) are the
times of departure of the aircraft. Check-in times (pre-departure
registration), as specified by the carrier or timetable, represent the latest
time when passengers can be accepted for departures and taking into
account the time needed to accommodate all the necessary formalities.
Flights cannot be delayed due to passengers and their delayed arrival
and in these cases, no liability can be assumed.

Objects whose transportation is prohibited
The transport of the following dangerous goods in passenger luggage is
forbidden for safety reasons:

1.

1. Compressed gases - (frozen at very low temperatures, flammable,
non-flammable and poisonous); such as propane-butane, liquid
nitrogen, oxygen including aqualungs.
2. Caustic substances such as acid and bases, wet batteries and
mercury.
3. Explosives, ammunition and pyrotechnic materials.
4. Flammable liquids and solids – lighters and refills for lighters,
matches, paints, and diluents.
5. Radioactive materials.
6. Safety boxes and cases with safety equipment installed.
7. Oxidants such as chlorinated lime and peroxides.
8. Poisons and infectious agents such as insecticides, herbicides, and
live virus material.
9. Other dangerous objects, such as magnetic material, irritants or
resistive substances
Medicines and toiletries which are essential and proportionate to flight
lengths, such as hairspray, perfume, and alcohol-containing medicines
can be transported in limited quantities. Many of these items may be
transported as air cargo, provided that their packaging complies with the
rules applicable to air cargo.
Further information is available on request.

Warning of liability limitations for baggage
Liability for loss, delay or damage to luggage is limited unless a higher
value is declared in advance and the applicable fee is paid. For most
international carriage (including national sections of international routes),
the limitation of the guarantee is approximately USD9.07 per pound (1 lb
= 0.45 kg), i.e. USD20.00 / kg for hand baggage and USD400.00 per
passenger. In the case of travel only between places in the US, a federal
regulation requires that any airline liability limit for the luggage be at
least USD2,500 per passenger. For certain types of items, an increased
rating may be declared. Some carriers do not assume any liability for
fragile, valuable or fast-decaying objects. Further information can be
obtained from the carrier.
Baggage
Checked baggage: Passengers are usually allowed to check-in baggage
free of charge, and restrictions may vary by airline, class, and route.

Exceeding the free baggage limit may be charged. For more information,
contact your travel or airline.
Hand baggage: Passengers are usually allowed to carry baggage free of
charge and restrictions may vary by airline, class, route, and type of
aircraft. It is advisable to limit the amount of cabin baggage to a
minimum. For more information, contact your travel agency or airline.
For more information and links to airline websites, visit http://www.iata.
org/bags.`,
        },
      ],
    },
    {
      title: "G. PRICELIST OF CHARGES IN THE GENERAL COMMERCIAL TERMS AND",
      content: `CONDITIONS`,
      subsections: [
        {
          title: "I. Information pertaining to Pelikán service charges:",
          content: `Pelikan charges a service charge for the provision of services related to
the conclusion of a transport contract and the provision of a ticket, with
every issued ticket. The service charge is part of the flight ticket price
and is included in the total amount of the flight ticket shown to the client
on the online offer, or in the case of an off-line booking in the offer sent
by Pelikán. This service charge is not charged additionally. The client is
notified of the amount of the service charge in the Payment details and
the sales receipt. The service charge is non-refundable if the legal and
contractual terms are met.
Charges listed in the price list are charges that are determined by Pelikán
and do not include charges charged by the service provider (airline,
accommodation, etc.) for the requested service for the given client. The
amount of the supplier's charge depends on the individual conditions, the
rules of which are contained in the business terms and conditions of the
particular supplier. All charges for services provided by Pelikán listed in
this price list are non-refundable and do not include VAT, as it is not
generally charged. If, due to the legal requirements, the VAT is charged,
the applicable current VAT rates will be added to the applicable charge in
this price list.`,
        },
        {
          title: "II. Types of charge",
          content: `AMENDMENT to a flight ticket prior to departure / after
departure at the client's request - change of date and / or
destination (if allowed by the airline), change of name,
39.00
including typing error in name or change of name in the
event of the client's marriage (if permitted by the airline)
and other permitted changes

Cancellation of flight tickets at the client’s request on the
date of the ticket issuance (a.k.a. VOID) - does not apply
to low-cost tickets except for some exceptions

33.00

AMENDMENTS to a flight ticket prior to or after departure
performed by the airline, cancelled flights, change of time
and the like

0.00

CANCELLATION of flight ticket at client's request (if
allowed by airline)

33.00

Purchase of additional piece of luggage to the ticket

10.00/pc

Purchase a specific seat for non-low-cost tickets

10.00

Purchase a specific seat for low-cost tickets

5.00
/direction

Online check-in and boarding pass provision

10.00/both
directions
/passenger

Purchase of priority boarding for low-cost tickets

10.00/both
directions
/passenger

Purchasing of special services to the ticket, for example,
transport of sports equipment, musical instruments,
transport of pets, etc.

10.00/pc

Premium assistance services fee

19.00/order

CHANGE of accommodation or tour at client's request purchaser or client's name, including change of name in
the case of marriage (if permitted by the supplier) requested more than 3 days prior to the commencement
of the accommodation or the tour

33.00

CHANGE of accommodation or tour at client's request purchaser or client's name, including change of name in
50.00

the case of marriage (if permitted by the supplier) requested 3 days or less prior to the commencement of
the accommodation or the tour

CHANGE of accommodation or tour (dates,
accommodation) at client's request (if permitted by the
supplier) - requested more than 3 days prior to the
commencement of the accommodation or the tour

33.00

CHANGE of accommodation or tour (dates,
accommodation) at client's request (if permitted by the
contractor) - requested 3 days or less prior to the
commencement of the accommodation or the tour

50.00

CANCELLATION of accommodation at the client's request
(if allowed by the supplier)

33.00

CANCELLATION of car park card at the client's request
(valid only for parking at Vienna, Bratislava and Prague
Airports)

25.00

CANCELLATION of visas at the client's request

33.00

Delivery by COURIER within the Slovak Republic within 3
working days from the payment of the booking

4.00

Delivery by COURIER to the Czech Republic within 5
working days from the payment of the booking

4.00

Delivery by COURIER outside of the Slovak Republic to
Hungary within 5 working days from the payment of the
booking

5.00

Delivery by COURIER outside of the Slovak Republic to
Poland within 5 working days from the payment of the
booking

24.00

Express delivery by COURIER within the Slovak Republic
by the next business day – it must be booked on the
previous business day before 4 p.m.

Price after
an individual
agreement

Express delivery by COURIER within Bratislava within 2
hours from placement of the booking – delivery only on
working days

Price after
an individual
agreement

up to €5
according to
the amount
Contractual fine for sending an arbitrarily rounded booking
of the
price on the part of the client
payment
above the
booking price`,
        },
      ],
    },
]

export default function Terms() {
  const slug = getEventSlugFromUrl()
  return (
    <div className="min-h-screen">
      <div className="py-10 @min-[40rem]:py-16" style={{ maxWidth: '100%', paddingLeft: '3rem', paddingRight: '3rem' }}>
        <a
          href={eventPath(slug)}
          className="mb-8 inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="size-4" />
          Back
        </a>

        <h1 className="text-3xl font-bold tracking-tight text-foreground @min-[40rem]:text-4xl">
          General Commercial Terms &amp; Conditions
        </h1>
        <p className="mt-2 text-base text-muted-foreground">
          pelicantravel.com s.r.o.
        </p>

        <div className="mt-10 space-y-10">
          {TERMS_SECTIONS.map((section) => (
            <section key={section.title}>
              <h2 className="text-lg font-semibold text-foreground">
                {section.title}
              </h2>
              {section.content && (
                <div className="mt-4 space-y-3 text-base leading-relaxed text-muted-foreground whitespace-pre-line">
                  {section.content}
                </div>
              )}
              {section.subsections && (
                <div className="mt-6 space-y-8">
                  {section.subsections.map((sub) => (
                    <div key={sub.title}>
                      <h3 className="text-base font-medium text-foreground">
                        {sub.title}
                      </h3>
                      <div className="mt-3 space-y-3 text-base leading-relaxed text-muted-foreground whitespace-pre-line">
                        {sub.content}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}
        </div>
      </div>

      <Footer eventSlug={slug} />
    </div>
  )
}